var countryJSON = [
/*
  {
    "FIELD1":"ISO",
    "FIELD2":"ISO3",
    "FIELD3":"ISO-Numeric",
    "FIELD4":"fips",
    "FIELD5":"Country",
    "FIELD6":"Capital",
    "FIELD7":"Area(in sq km)",
    "FIELD8":"Population",
    "FIELD9":"Continent",
    "FIELD10":"tld",
    "FIELD11":"CurrencyCode",
    "FIELD12":"CurrencyName",
    "FIELD13":"Phone",
    "FIELD14":"Postal Code Format",
    "FIELD15":"Postal Code Regex",
    "FIELD16":"Languages",
    "FIELD17":"geonameid",
    "FIELD18":"neighbours",
    "FIELD19":"EquivalentFipsCode"
  },
*/
  {
    "FIELD1":"AD",
    "FIELD2":"AND",
    "FIELD3":"020",
    "FIELD4":"AN",
    "FIELD5":"Andorra",
    "FIELD6":"Andorra la Vella",
    "FIELD7":"468",
    "FIELD8":"84000",
    "FIELD9":"EU",
    "FIELD10":".ad",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"376",
    "FIELD14":"AD###",
    "FIELD15":"^(?:AD)*(\\d{3})$",
    "FIELD16":"ca",
    "FIELD17":"3041565",
    "FIELD18":"ES,FR",
    "FIELD19":""
  },
  {
    "FIELD1":"AE",
    "FIELD2":"ARE",
    "FIELD3":"784",
    "FIELD4":"AE",
    "FIELD5":"United Arab Emirates",
    "FIELD6":"Abu Dhabi",
    "FIELD7":"82880",
    "FIELD8":"4975593",
    "FIELD9":"AS",
    "FIELD10":".ae",
    "FIELD11":"AED",
    "FIELD12":"Dirham",
    "FIELD13":"971",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-AE,fa,en,hi,ur",
    "FIELD17":"290557",
    "FIELD18":"SA,OM",
    "FIELD19":""
  },
  {
    "FIELD1":"AF",
    "FIELD2":"AFG",
    "FIELD3":"004",
    "FIELD4":"AF",
    "FIELD5":"Afghanistan",
    "FIELD6":"Kabul",
    "FIELD7":"647500",
    "FIELD8":"29121286",
    "FIELD9":"AS",
    "FIELD10":".af",
    "FIELD11":"AFN",
    "FIELD12":"Afghani",
    "FIELD13":"93",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fa-AF,ps,uz-AF,tk",
    "FIELD17":"1149361",
    "FIELD18":"TM,CN,IR,TJ,PK,UZ",
    "FIELD19":""
  },
  {
    "FIELD1":"AG",
    "FIELD2":"ATG",
    "FIELD3":"028",
    "FIELD4":"AC",
    "FIELD5":"Antigua and Barbuda",
    "FIELD6":"St. John's",
    "FIELD7":"443",
    "FIELD8":"86754",
    "FIELD9":"NA",
    "FIELD10":".ag",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-268",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-AG",
    "FIELD17":"3576396",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AI",
    "FIELD2":"AIA",
    "FIELD3":"660",
    "FIELD4":"AV",
    "FIELD5":"Anguilla",
    "FIELD6":"The Valley",
    "FIELD7":"102",
    "FIELD8":"13254",
    "FIELD9":"NA",
    "FIELD10":".ai",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-264",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-AI",
    "FIELD17":"3573511",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AL",
    "FIELD2":"ALB",
    "FIELD3":"008",
    "FIELD4":"AL",
    "FIELD5":"Albania",
    "FIELD6":"Tirana",
    "FIELD7":"28748",
    "FIELD8":"2986952",
    "FIELD9":"EU",
    "FIELD10":".al",
    "FIELD11":"ALL",
    "FIELD12":"Lek",
    "FIELD13":"355",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"sq,el",
    "FIELD17":"783754",
    "FIELD18":"MK,GR,ME,RS,XK",
    "FIELD19":""
  },
  {
    "FIELD1":"AM",
    "FIELD2":"ARM",
    "FIELD3":"051",
    "FIELD4":"AM",
    "FIELD5":"Armenia",
    "FIELD6":"Yerevan",
    "FIELD7":"29800",
    "FIELD8":"2968000",
    "FIELD9":"AS",
    "FIELD10":".am",
    "FIELD11":"AMD",
    "FIELD12":"Dram",
    "FIELD13":"374",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"hy",
    "FIELD17":"174982",
    "FIELD18":"GE,IR,AZ,TR",
    "FIELD19":""
  },
  {
    "FIELD1":"AO",
    "FIELD2":"AGO",
    "FIELD3":"024",
    "FIELD4":"AO",
    "FIELD5":"Angola",
    "FIELD6":"Luanda",
    "FIELD7":"1246700",
    "FIELD8":"13068161",
    "FIELD9":"AF",
    "FIELD10":".ao",
    "FIELD11":"AOA",
    "FIELD12":"Kwanza",
    "FIELD13":"244",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"pt-AO",
    "FIELD17":"3351879",
    "FIELD18":"CD,NA,ZM,CG",
    "FIELD19":""
  },
  {
    "FIELD1":"AQ",
    "FIELD2":"ATA",
    "FIELD3":"010",
    "FIELD4":"AY",
    "FIELD5":"Antarctica",
    "FIELD6":"",
    "FIELD7":"14000000",
    "FIELD8":"0",
    "FIELD9":"AN",
    "FIELD10":".aq",
    "FIELD11":"",
    "FIELD12":"",
    "FIELD13":"",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"",
    "FIELD17":"6697173",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AR",
    "FIELD2":"ARG",
    "FIELD3":"032",
    "FIELD4":"AR",
    "FIELD5":"Argentina",
    "FIELD6":"Buenos Aires",
    "FIELD7":"2766890",
    "FIELD8":"41343201",
    "FIELD9":"SA",
    "FIELD10":".ar",
    "FIELD11":"ARS",
    "FIELD12":"Peso",
    "FIELD13":"54",
    "FIELD14":"@####@@@",
    "FIELD15":"^([A-Z]\\d{4}[A-Z]{3})$",
    "FIELD16":"es-AR,en,it,de,fr,gn",
    "FIELD17":"3865483",
    "FIELD18":"CL,BO,UY,PY,BR",
    "FIELD19":""
  },
  {
    "FIELD1":"AS",
    "FIELD2":"ASM",
    "FIELD3":"016",
    "FIELD4":"AQ",
    "FIELD5":"American Samoa",
    "FIELD6":"Pago Pago",
    "FIELD7":"199",
    "FIELD8":"57881",
    "FIELD9":"OC",
    "FIELD10":".as",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-684",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-AS,sm,to",
    "FIELD17":"5880801",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AT",
    "FIELD2":"AUT",
    "FIELD3":"040",
    "FIELD4":"AU",
    "FIELD5":"Austria",
    "FIELD6":"Vienna",
    "FIELD7":"83858",
    "FIELD8":"8205000",
    "FIELD9":"EU",
    "FIELD10":".at",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"43",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"de-AT,hr,hu,sl",
    "FIELD17":"2782113",
    "FIELD18":"CH,DE,HU,SK,CZ,IT,SI,LI",
    "FIELD19":""
  },
  {
    "FIELD1":"AU",
    "FIELD2":"AUS",
    "FIELD3":"036",
    "FIELD4":"AS",
    "FIELD5":"Australia",
    "FIELD6":"Canberra",
    "FIELD7":"7686850",
    "FIELD8":"21515754",
    "FIELD9":"OC",
    "FIELD10":".au",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"61",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"en-AU",
    "FIELD17":"2077456",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AW",
    "FIELD2":"ABW",
    "FIELD3":"533",
    "FIELD4":"AA",
    "FIELD5":"Aruba",
    "FIELD6":"Oranjestad",
    "FIELD7":"193",
    "FIELD8":"71566",
    "FIELD9":"NA",
    "FIELD10":".aw",
    "FIELD11":"AWG",
    "FIELD12":"Guilder",
    "FIELD13":"297",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"nl-AW,es,en",
    "FIELD17":"3577279",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"AX",
    "FIELD2":"ALA",
    "FIELD3":"248",
    "FIELD4":"",
    "FIELD5":"Aland Islands",
    "FIELD6":"Mariehamn",
    "FIELD7":"1580",
    "FIELD8":"26711",
    "FIELD9":"EU",
    "FIELD10":".ax",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"+358-18",
    "FIELD14":"#####",
    "FIELD15":"^(?:FI)*(\\d{5})$",
    "FIELD16":"sv-AX",
    "FIELD17":"661882",
    "FIELD18":"",
    "FIELD19":"FI"
  },
  {
    "FIELD1":"AZ",
    "FIELD2":"AZE",
    "FIELD3":"031",
    "FIELD4":"AJ",
    "FIELD5":"Azerbaijan",
    "FIELD6":"Baku",
    "FIELD7":"86600",
    "FIELD8":"8303512",
    "FIELD9":"AS",
    "FIELD10":".az",
    "FIELD11":"AZN",
    "FIELD12":"Manat",
    "FIELD13":"994",
    "FIELD14":"AZ ####",
    "FIELD15":"^(?:AZ)*(\\d{4})$",
    "FIELD16":"az,ru,hy",
    "FIELD17":"587116",
    "FIELD18":"GE,IR,AM,TR,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"BA",
    "FIELD2":"BIH",
    "FIELD3":"070",
    "FIELD4":"BK",
    "FIELD5":"Bosnia and Herzegovina",
    "FIELD6":"Sarajevo",
    "FIELD7":"51129",
    "FIELD8":"4590000",
    "FIELD9":"EU",
    "FIELD10":".ba",
    "FIELD11":"BAM",
    "FIELD12":"Marka",
    "FIELD13":"387",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"bs,hr-BA,sr-BA",
    "FIELD17":"3277605",
    "FIELD18":"HR,ME,RS",
    "FIELD19":""
  },
  {
    "FIELD1":"BB",
    "FIELD2":"BRB",
    "FIELD3":"052",
    "FIELD4":"BB",
    "FIELD5":"Barbados",
    "FIELD6":"Bridgetown",
    "FIELD7":"431",
    "FIELD8":"285653",
    "FIELD9":"NA",
    "FIELD10":".bb",
    "FIELD11":"BBD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-246",
    "FIELD14":"BB#####",
    "FIELD15":"^(?:BB)*(\\d{5})$",
    "FIELD16":"en-BB",
    "FIELD17":"3374084",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BD",
    "FIELD2":"BGD",
    "FIELD3":"050",
    "FIELD4":"BG",
    "FIELD5":"Bangladesh",
    "FIELD6":"Dhaka",
    "FIELD7":"144000",
    "FIELD8":"156118464",
    "FIELD9":"AS",
    "FIELD10":".bd",
    "FIELD11":"BDT",
    "FIELD12":"Taka",
    "FIELD13":"880",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"bn-BD,en",
    "FIELD17":"1210997",
    "FIELD18":"MM,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"BE",
    "FIELD2":"BEL",
    "FIELD3":"056",
    "FIELD4":"BE",
    "FIELD5":"Belgium",
    "FIELD6":"Brussels",
    "FIELD7":"30510",
    "FIELD8":"10403000",
    "FIELD9":"EU",
    "FIELD10":".be",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"32",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"nl-BE,fr-BE,de-BE",
    "FIELD17":"2802361",
    "FIELD18":"DE,NL,LU,FR",
    "FIELD19":""
  },
  {
    "FIELD1":"BF",
    "FIELD2":"BFA",
    "FIELD3":"854",
    "FIELD4":"UV",
    "FIELD5":"Burkina Faso",
    "FIELD6":"Ouagadougou",
    "FIELD7":"274200",
    "FIELD8":"16241811",
    "FIELD9":"AF",
    "FIELD10":".bf",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"226",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-BF",
    "FIELD17":"2361809",
    "FIELD18":"NE,BJ,GH,CI,TG,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"BG",
    "FIELD2":"BGR",
    "FIELD3":"100",
    "FIELD4":"BU",
    "FIELD5":"Bulgaria",
    "FIELD6":"Sofia",
    "FIELD7":"110910",
    "FIELD8":"7148785",
    "FIELD9":"EU",
    "FIELD10":".bg",
    "FIELD11":"BGN",
    "FIELD12":"Lev",
    "FIELD13":"359",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"bg,tr-BG,rom",
    "FIELD17":"732800",
    "FIELD18":"MK,GR,RO,TR,RS",
    "FIELD19":""
  },
  {
    "FIELD1":"BH",
    "FIELD2":"BHR",
    "FIELD3":"048",
    "FIELD4":"BA",
    "FIELD5":"Bahrain",
    "FIELD6":"Manama",
    "FIELD7":"665",
    "FIELD8":"738004",
    "FIELD9":"AS",
    "FIELD10":".bh",
    "FIELD11":"BHD",
    "FIELD12":"Dinar",
    "FIELD13":"973",
    "FIELD14":"####|###",
    "FIELD15":"^(\\d{3}\\d?)$",
    "FIELD16":"ar-BH,en,fa,ur",
    "FIELD17":"290291",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BI",
    "FIELD2":"BDI",
    "FIELD3":"108",
    "FIELD4":"BY",
    "FIELD5":"Burundi",
    "FIELD6":"Bujumbura",
    "FIELD7":"27830",
    "FIELD8":"9863117",
    "FIELD9":"AF",
    "FIELD10":".bi",
    "FIELD11":"BIF",
    "FIELD12":"Franc",
    "FIELD13":"257",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-BI,rn",
    "FIELD17":"433561",
    "FIELD18":"TZ,CD,RW",
    "FIELD19":""
  },
  {
    "FIELD1":"BJ",
    "FIELD2":"BEN",
    "FIELD3":"204",
    "FIELD4":"BN",
    "FIELD5":"Benin",
    "FIELD6":"Porto-Novo",
    "FIELD7":"112620",
    "FIELD8":"9056010",
    "FIELD9":"AF",
    "FIELD10":".bj",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"229",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-BJ",
    "FIELD17":"2395170",
    "FIELD18":"NE,TG,BF,NG",
    "FIELD19":""
  },
  {
    "FIELD1":"BL",
    "FIELD2":"BLM",
    "FIELD3":"652",
    "FIELD4":"TB",
    "FIELD5":"Saint Barthelemy",
    "FIELD6":"Gustavia",
    "FIELD7":"21",
    "FIELD8":"8450",
    "FIELD9":"NA",
    "FIELD10":".gp",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"590",
    "FIELD14":"### ###",
    "FIELD15":"",
    "FIELD16":"fr",
    "FIELD17":"3578476",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BM",
    "FIELD2":"BMU",
    "FIELD3":"060",
    "FIELD4":"BD",
    "FIELD5":"Bermuda",
    "FIELD6":"Hamilton",
    "FIELD7":"53",
    "FIELD8":"65365",
    "FIELD9":"NA",
    "FIELD10":".bm",
    "FIELD11":"BMD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-441",
    "FIELD14":"@@ ##",
    "FIELD15":"^([A-Z]{2}\\d{2})$",
    "FIELD16":"en-BM,pt",
    "FIELD17":"3573345",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BN",
    "FIELD2":"BRN",
    "FIELD3":"096",
    "FIELD4":"BX",
    "FIELD5":"Brunei",
    "FIELD6":"Bandar Seri Begawan",
    "FIELD7":"5770",
    "FIELD8":"395027",
    "FIELD9":"AS",
    "FIELD10":".bn",
    "FIELD11":"BND",
    "FIELD12":"Dollar",
    "FIELD13":"673",
    "FIELD14":"@@####",
    "FIELD15":"^([A-Z]{2}\\d{4})$",
    "FIELD16":"ms-BN,en-BN",
    "FIELD17":"1820814",
    "FIELD18":"MY",
    "FIELD19":""
  },
  {
    "FIELD1":"BO",
    "FIELD2":"BOL",
    "FIELD3":"068",
    "FIELD4":"BL",
    "FIELD5":"Bolivia",
    "FIELD6":"Sucre",
    "FIELD7":"1098580",
    "FIELD8":"9947418",
    "FIELD9":"SA",
    "FIELD10":".bo",
    "FIELD11":"BOB",
    "FIELD12":"Boliviano",
    "FIELD13":"591",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"es-BO,qu,ay",
    "FIELD17":"3923057",
    "FIELD18":"PE,CL,PY,BR,AR",
    "FIELD19":""
  },
  {
    "FIELD1":"BQ",
    "FIELD2":"BES",
    "FIELD3":"535",
    "FIELD4":"",
    "FIELD5":"Bonaire, Saint Eustatius and Saba ",
    "FIELD6":"",
    "FIELD7":"328",
    "FIELD8":"18012",
    "FIELD9":"NA",
    "FIELD10":".bq",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"599",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"nl,pap,en",
    "FIELD17":"7626844",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BR",
    "FIELD2":"BRA",
    "FIELD3":"076",
    "FIELD4":"BR",
    "FIELD5":"Brazil",
    "FIELD6":"Brasilia",
    "FIELD7":"8511965",
    "FIELD8":"201103330",
    "FIELD9":"SA",
    "FIELD10":".br",
    "FIELD11":"BRL",
    "FIELD12":"Real",
    "FIELD13":"55",
    "FIELD14":"#####-###",
    "FIELD15":"^(\\d{8})$",
    "FIELD16":"pt-BR,es,en,fr",
    "FIELD17":"3469034",
    "FIELD18":"SR,PE,BO,UY,GY,PY,GF,VE,CO,AR",
    "FIELD19":""
  },
  {
    "FIELD1":"BS",
    "FIELD2":"BHS",
    "FIELD3":"044",
    "FIELD4":"BF",
    "FIELD5":"Bahamas",
    "FIELD6":"Nassau",
    "FIELD7":"13940",
    "FIELD8":"301790",
    "FIELD9":"NA",
    "FIELD10":".bs",
    "FIELD11":"BSD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-242",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-BS",
    "FIELD17":"3572887",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BT",
    "FIELD2":"BTN",
    "FIELD3":"064",
    "FIELD4":"BT",
    "FIELD5":"Bhutan",
    "FIELD6":"Thimphu",
    "FIELD7":"47000",
    "FIELD8":"699847",
    "FIELD9":"AS",
    "FIELD10":".bt",
    "FIELD11":"BTN",
    "FIELD12":"Ngultrum",
    "FIELD13":"975",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"dz",
    "FIELD17":"1252634",
    "FIELD18":"CN,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"BV",
    "FIELD2":"BVT",
    "FIELD3":"074",
    "FIELD4":"BV",
    "FIELD5":"Bouvet Island",
    "FIELD6":"",
    "FIELD7":"49",
    "FIELD8":"0",
    "FIELD9":"AN",
    "FIELD10":".bv",
    "FIELD11":"NOK",
    "FIELD12":"Krone",
    "FIELD13":"",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"",
    "FIELD17":"3371123",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"BW",
    "FIELD2":"BWA",
    "FIELD3":"072",
    "FIELD4":"BC",
    "FIELD5":"Botswana",
    "FIELD6":"Gaborone",
    "FIELD7":"600370",
    "FIELD8":"2029307",
    "FIELD9":"AF",
    "FIELD10":".bw",
    "FIELD11":"BWP",
    "FIELD12":"Pula",
    "FIELD13":"267",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-BW,tn-BW",
    "FIELD17":"933860",
    "FIELD18":"ZW,ZA,NA",
    "FIELD19":""
  },
  {
    "FIELD1":"BY",
    "FIELD2":"BLR",
    "FIELD3":"112",
    "FIELD4":"BO",
    "FIELD5":"Belarus",
    "FIELD6":"Minsk",
    "FIELD7":"207600",
    "FIELD8":"9685000",
    "FIELD9":"EU",
    "FIELD10":".by",
    "FIELD11":"BYR",
    "FIELD12":"Ruble",
    "FIELD13":"375",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"be,ru",
    "FIELD17":"630336",
    "FIELD18":"PL,LT,UA,RU,LV",
    "FIELD19":""
  },
  {
    "FIELD1":"BZ",
    "FIELD2":"BLZ",
    "FIELD3":"084",
    "FIELD4":"BH",
    "FIELD5":"Belize",
    "FIELD6":"Belmopan",
    "FIELD7":"22966",
    "FIELD8":"314522",
    "FIELD9":"NA",
    "FIELD10":".bz",
    "FIELD11":"BZD",
    "FIELD12":"Dollar",
    "FIELD13":"501",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-BZ,es",
    "FIELD17":"3582678",
    "FIELD18":"GT,MX",
    "FIELD19":""
  },
  {
    "FIELD1":"CA",
    "FIELD2":"CAN",
    "FIELD3":"124",
    "FIELD4":"CA",
    "FIELD5":"Canada",
    "FIELD6":"Ottawa",
    "FIELD7":"9984670",
    "FIELD8":"33679000",
    "FIELD9":"NA",
    "FIELD10":".ca",
    "FIELD11":"CAD",
    "FIELD12":"Dollar",
    "FIELD13":"1",
    "FIELD14":"@#@ #@#",
    "FIELD15":"^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$ ",
    "FIELD16":"en-CA,fr-CA,iu",
    "FIELD17":"6251999",
    "FIELD18":"US",
    "FIELD19":""
  },
  {
    "FIELD1":"CC",
    "FIELD2":"CCK",
    "FIELD3":"166",
    "FIELD4":"CK",
    "FIELD5":"Cocos Islands",
    "FIELD6":"West Island",
    "FIELD7":"14",
    "FIELD8":"628",
    "FIELD9":"AS",
    "FIELD10":".cc",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"61",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ms-CC,en",
    "FIELD17":"1547376",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CD",
    "FIELD2":"COD",
    "FIELD3":"180",
    "FIELD4":"CG",
    "FIELD5":"Democratic Republic of the Congo",
    "FIELD6":"Kinshasa",
    "FIELD7":"2345410",
    "FIELD8":"70916439",
    "FIELD9":"AF",
    "FIELD10":".cd",
    "FIELD11":"CDF",
    "FIELD12":"Franc",
    "FIELD13":"243",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-CD,ln,kg",
    "FIELD17":"203312",
    "FIELD18":"TZ,CF,SS,RW,ZM,BI,UG,CG,AO",
    "FIELD19":""
  },
  {
    "FIELD1":"CF",
    "FIELD2":"CAF",
    "FIELD3":"140",
    "FIELD4":"CT",
    "FIELD5":"Central African Republic",
    "FIELD6":"Bangui",
    "FIELD7":"622984",
    "FIELD8":"4844927",
    "FIELD9":"AF",
    "FIELD10":".cf",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"236",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-CF,sg,ln,kg",
    "FIELD17":"239880",
    "FIELD18":"TD,SD,CD,SS,CM,CG",
    "FIELD19":""
  },
  {
    "FIELD1":"CG",
    "FIELD2":"COG",
    "FIELD3":"178",
    "FIELD4":"CF",
    "FIELD5":"Republic of the Congo",
    "FIELD6":"Brazzaville",
    "FIELD7":"342000",
    "FIELD8":"3039126",
    "FIELD9":"AF",
    "FIELD10":".cg",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"242",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-CG,kg,ln-CG",
    "FIELD17":"2260494",
    "FIELD18":"CF,GA,CD,CM,AO",
    "FIELD19":""
  },
  {
    "FIELD1":"CH",
    "FIELD2":"CHE",
    "FIELD3":"756",
    "FIELD4":"SZ",
    "FIELD5":"Switzerland",
    "FIELD6":"Berne",
    "FIELD7":"41290",
    "FIELD8":"7581000",
    "FIELD9":"EU",
    "FIELD10":".ch",
    "FIELD11":"CHF",
    "FIELD12":"Franc",
    "FIELD13":"41",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"de-CH,fr-CH,it-CH,rm",
    "FIELD17":"2658434",
    "FIELD18":"DE,IT,LI,FR,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"CI",
    "FIELD2":"CIV",
    "FIELD3":"384",
    "FIELD4":"IV",
    "FIELD5":"Ivory Coast",
    "FIELD6":"Yamoussoukro",
    "FIELD7":"322460",
    "FIELD8":"21058798",
    "FIELD9":"AF",
    "FIELD10":".ci",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"225",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-CI",
    "FIELD17":"2287781",
    "FIELD18":"LR,GH,GN,BF,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"CK",
    "FIELD2":"COK",
    "FIELD3":"184",
    "FIELD4":"CW",
    "FIELD5":"Cook Islands",
    "FIELD6":"Avarua",
    "FIELD7":"240",
    "FIELD8":"21388",
    "FIELD9":"OC",
    "FIELD10":".ck",
    "FIELD11":"NZD",
    "FIELD12":"Dollar",
    "FIELD13":"682",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-CK,mi",
    "FIELD17":"1899402",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CL",
    "FIELD2":"CHL",
    "FIELD3":"152",
    "FIELD4":"CI",
    "FIELD5":"Chile",
    "FIELD6":"Santiago",
    "FIELD7":"756950",
    "FIELD8":"16746491",
    "FIELD9":"SA",
    "FIELD10":".cl",
    "FIELD11":"CLP",
    "FIELD12":"Peso",
    "FIELD13":"56",
    "FIELD14":"#######",
    "FIELD15":"^(\\d{7})$",
    "FIELD16":"es-CL",
    "FIELD17":"3895114",
    "FIELD18":"PE,BO,AR",
    "FIELD19":""
  },
  {
    "FIELD1":"CM",
    "FIELD2":"CMR",
    "FIELD3":"120",
    "FIELD4":"CM",
    "FIELD5":"Cameroon",
    "FIELD6":"Yaounde",
    "FIELD7":"475440",
    "FIELD8":"19294149",
    "FIELD9":"AF",
    "FIELD10":".cm",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"237",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-CM,fr-CM",
    "FIELD17":"2233387",
    "FIELD18":"TD,CF,GA,GQ,CG,NG",
    "FIELD19":""
  },
  {
    "FIELD1":"CN",
    "FIELD2":"CHN",
    "FIELD3":"156",
    "FIELD4":"CH",
    "FIELD5":"China",
    "FIELD6":"Beijing",
    "FIELD7":"9596960",
    "FIELD8":"1330044000",
    "FIELD9":"AS",
    "FIELD10":".cn",
    "FIELD11":"CNY",
    "FIELD12":"Yuan Renminbi",
    "FIELD13":"86",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"zh-CN,yue,wuu,dta,ug,za",
    "FIELD17":"1814991",
    "FIELD18":"LA,BT,TJ,KZ,MN,AF,NP,MM,KG,PK,KP,RU,VN,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"CO",
    "FIELD2":"COL",
    "FIELD3":"170",
    "FIELD4":"CO",
    "FIELD5":"Colombia",
    "FIELD6":"Bogota",
    "FIELD7":"1138910",
    "FIELD8":"47790000",
    "FIELD9":"SA",
    "FIELD10":".co",
    "FIELD11":"COP",
    "FIELD12":"Peso",
    "FIELD13":"57",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"es-CO",
    "FIELD17":"3686110",
    "FIELD18":"EC,PE,PA,BR,VE",
    "FIELD19":""
  },
  {
    "FIELD1":"CR",
    "FIELD2":"CRI",
    "FIELD3":"188",
    "FIELD4":"CS",
    "FIELD5":"Costa Rica",
    "FIELD6":"San Jose",
    "FIELD7":"51100",
    "FIELD8":"4516220",
    "FIELD9":"NA",
    "FIELD10":".cr",
    "FIELD11":"CRC",
    "FIELD12":"Colon",
    "FIELD13":"506",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"es-CR,en",
    "FIELD17":"3624060",
    "FIELD18":"PA,NI",
    "FIELD19":""
  },
  {
    "FIELD1":"CU",
    "FIELD2":"CUB",
    "FIELD3":"192",
    "FIELD4":"CU",
    "FIELD5":"Cuba",
    "FIELD6":"Havana",
    "FIELD7":"110860",
    "FIELD8":"11423000",
    "FIELD9":"NA",
    "FIELD10":".cu",
    "FIELD11":"CUP",
    "FIELD12":"Peso",
    "FIELD13":"53",
    "FIELD14":"CP #####",
    "FIELD15":"^(?:CP)*(\\d{5})$",
    "FIELD16":"es-CU",
    "FIELD17":"3562981",
    "FIELD18":"US",
    "FIELD19":""
  },
  {
    "FIELD1":"CV",
    "FIELD2":"CPV",
    "FIELD3":"132",
    "FIELD4":"CV",
    "FIELD5":"Cape Verde",
    "FIELD6":"Praia",
    "FIELD7":"4033",
    "FIELD8":"508659",
    "FIELD9":"AF",
    "FIELD10":".cv",
    "FIELD11":"CVE",
    "FIELD12":"Escudo",
    "FIELD13":"238",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"pt-CV",
    "FIELD17":"3374766",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CW",
    "FIELD2":"CUW",
    "FIELD3":"531",
    "FIELD4":"UC",
    "FIELD5":"Curacao",
    "FIELD6":" Willemstad",
    "FIELD7":"444",
    "FIELD8":"141766",
    "FIELD9":"NA",
    "FIELD10":".cw",
    "FIELD11":"ANG",
    "FIELD12":"Guilder",
    "FIELD13":"599",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"nl,pap",
    "FIELD17":"7626836",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CX",
    "FIELD2":"CXR",
    "FIELD3":"162",
    "FIELD4":"KT",
    "FIELD5":"Christmas Island",
    "FIELD6":"Flying Fish Cove",
    "FIELD7":"135",
    "FIELD8":"1500",
    "FIELD9":"AS",
    "FIELD10":".cx",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"61",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"en,zh,ms-CC",
    "FIELD17":"2078138",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CY",
    "FIELD2":"CYP",
    "FIELD3":"196",
    "FIELD4":"CY",
    "FIELD5":"Cyprus",
    "FIELD6":"Nicosia",
    "FIELD7":"9250",
    "FIELD8":"1102677",
    "FIELD9":"EU",
    "FIELD10":".cy",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"357",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"el-CY,tr-CY,en",
    "FIELD17":"146669",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"CZ",
    "FIELD2":"CZE",
    "FIELD3":"203",
    "FIELD4":"EZ",
    "FIELD5":"Czech Republic",
    "FIELD6":"Prague",
    "FIELD7":"78866",
    "FIELD8":"10476000",
    "FIELD9":"EU",
    "FIELD10":".cz",
    "FIELD11":"CZK",
    "FIELD12":"Koruna",
    "FIELD13":"420",
    "FIELD14":"### ##",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"cs,sk",
    "FIELD17":"3077311",
    "FIELD18":"PL,DE,SK,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"DE",
    "FIELD2":"DEU",
    "FIELD3":"276",
    "FIELD4":"GM",
    "FIELD5":"Germany",
    "FIELD6":"Berlin",
    "FIELD7":"357021",
    "FIELD8":"81802257",
    "FIELD9":"EU",
    "FIELD10":".de",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"49",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"de",
    "FIELD17":"2921044",
    "FIELD18":"CH,PL,NL,DK,BE,CZ,LU,FR,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"DJ",
    "FIELD2":"DJI",
    "FIELD3":"262",
    "FIELD4":"DJ",
    "FIELD5":"Djibouti",
    "FIELD6":"Djibouti",
    "FIELD7":"23000",
    "FIELD8":"740528",
    "FIELD9":"AF",
    "FIELD10":".dj",
    "FIELD11":"DJF",
    "FIELD12":"Franc",
    "FIELD13":"253",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-DJ,ar,so-DJ,aa",
    "FIELD17":"223816",
    "FIELD18":"ER,ET,SO",
    "FIELD19":""
  },
  {
    "FIELD1":"DK",
    "FIELD2":"DNK",
    "FIELD3":"208",
    "FIELD4":"DA",
    "FIELD5":"Denmark",
    "FIELD6":"Copenhagen",
    "FIELD7":"43094",
    "FIELD8":"5484000",
    "FIELD9":"EU",
    "FIELD10":".dk",
    "FIELD11":"DKK",
    "FIELD12":"Krone",
    "FIELD13":"45",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"da-DK,en,fo,de-DK",
    "FIELD17":"2623032",
    "FIELD18":"DE",
    "FIELD19":""
  },
  {
    "FIELD1":"DM",
    "FIELD2":"DMA",
    "FIELD3":"212",
    "FIELD4":"DO",
    "FIELD5":"Dominica",
    "FIELD6":"Roseau",
    "FIELD7":"754",
    "FIELD8":"72813",
    "FIELD9":"NA",
    "FIELD10":".dm",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-767",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-DM",
    "FIELD17":"3575830",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"DO",
    "FIELD2":"DOM",
    "FIELD3":"214",
    "FIELD4":"DR",
    "FIELD5":"Dominican Republic",
    "FIELD6":"Santo Domingo",
    "FIELD7":"48730",
    "FIELD8":"9823821",
    "FIELD9":"NA",
    "FIELD10":".do",
    "FIELD11":"DOP",
    "FIELD12":"Peso",
    "FIELD13":"+1-809 and 1-829",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"es-DO",
    "FIELD17":"3508796",
    "FIELD18":"HT",
    "FIELD19":""
  },
  {
    "FIELD1":"DZ",
    "FIELD2":"DZA",
    "FIELD3":"012",
    "FIELD4":"AG",
    "FIELD5":"Algeria",
    "FIELD6":"Algiers",
    "FIELD7":"2381740",
    "FIELD8":"34586184",
    "FIELD9":"AF",
    "FIELD10":".dz",
    "FIELD11":"DZD",
    "FIELD12":"Dinar",
    "FIELD13":"213",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-DZ",
    "FIELD17":"2589581",
    "FIELD18":"NE,EH,LY,MR,TN,MA,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"EC",
    "FIELD2":"ECU",
    "FIELD3":"218",
    "FIELD4":"EC",
    "FIELD5":"Ecuador",
    "FIELD6":"Quito",
    "FIELD7":"283560",
    "FIELD8":"14790608",
    "FIELD9":"SA",
    "FIELD10":".ec",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"593",
    "FIELD14":"@####@",
    "FIELD15":"^([a-zA-Z]\\d{4}[a-zA-Z])$",
    "FIELD16":"es-EC",
    "FIELD17":"3658394",
    "FIELD18":"PE,CO",
    "FIELD19":""
  },
  {
    "FIELD1":"EE",
    "FIELD2":"EST",
    "FIELD3":"233",
    "FIELD4":"EN",
    "FIELD5":"Estonia",
    "FIELD6":"Tallinn",
    "FIELD7":"45226",
    "FIELD8":"1291170",
    "FIELD9":"EU",
    "FIELD10":".ee",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"372",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"et,ru",
    "FIELD17":"453733",
    "FIELD18":"RU,LV",
    "FIELD19":""
  },
  {
    "FIELD1":"EG",
    "FIELD2":"EGY",
    "FIELD3":"818",
    "FIELD4":"EG",
    "FIELD5":"Egypt",
    "FIELD6":"Cairo",
    "FIELD7":"1001450",
    "FIELD8":"80471869",
    "FIELD9":"AF",
    "FIELD10":".eg",
    "FIELD11":"EGP",
    "FIELD12":"Pound",
    "FIELD13":"20",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-EG,en,fr",
    "FIELD17":"357994",
    "FIELD18":"LY,SD,IL,PS",
    "FIELD19":""
  },
  {
    "FIELD1":"EH",
    "FIELD2":"ESH",
    "FIELD3":"732",
    "FIELD4":"WI",
    "FIELD5":"Western Sahara",
    "FIELD6":"El-Aaiun",
    "FIELD7":"266000",
    "FIELD8":"273008",
    "FIELD9":"AF",
    "FIELD10":".eh",
    "FIELD11":"MAD",
    "FIELD12":"Dirham",
    "FIELD13":"212",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar,mey",
    "FIELD17":"2461445",
    "FIELD18":"DZ,MR,MA",
    "FIELD19":""
  },
  {
    "FIELD1":"ER",
    "FIELD2":"ERI",
    "FIELD3":"232",
    "FIELD4":"ER",
    "FIELD5":"Eritrea",
    "FIELD6":"Asmara",
    "FIELD7":"121320",
    "FIELD8":"5792984",
    "FIELD9":"AF",
    "FIELD10":".er",
    "FIELD11":"ERN",
    "FIELD12":"Nakfa",
    "FIELD13":"291",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"aa-ER,ar,tig,kun,ti-ER",
    "FIELD17":"338010",
    "FIELD18":"ET,SD,DJ",
    "FIELD19":""
  },
  {
    "FIELD1":"ES",
    "FIELD2":"ESP",
    "FIELD3":"724",
    "FIELD4":"SP",
    "FIELD5":"Spain",
    "FIELD6":"Madrid",
    "FIELD7":"504782",
    "FIELD8":"46505963",
    "FIELD9":"EU",
    "FIELD10":".es",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"34",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"es-ES,ca,gl,eu,oc",
    "FIELD17":"2510769",
    "FIELD18":"AD,PT,GI,FR,MA",
    "FIELD19":""
  },
  {
    "FIELD1":"ET",
    "FIELD2":"ETH",
    "FIELD3":"231",
    "FIELD4":"ET",
    "FIELD5":"Ethiopia",
    "FIELD6":"Addis Ababa",
    "FIELD7":"1127127",
    "FIELD8":"88013491",
    "FIELD9":"AF",
    "FIELD10":".et",
    "FIELD11":"ETB",
    "FIELD12":"Birr",
    "FIELD13":"251",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"am,en-ET,om-ET,ti-ET,so-ET,sid",
    "FIELD17":"337996",
    "FIELD18":"ER,KE,SD,SS,SO,DJ",
    "FIELD19":""
  },
  {
    "FIELD1":"FI",
    "FIELD2":"FIN",
    "FIELD3":"246",
    "FIELD4":"FI",
    "FIELD5":"Finland",
    "FIELD6":"Helsinki",
    "FIELD7":"337030",
    "FIELD8":"5244000",
    "FIELD9":"EU",
    "FIELD10":".fi",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"358",
    "FIELD14":"#####",
    "FIELD15":"^(?:FI)*(\\d{5})$",
    "FIELD16":"fi-FI,sv-FI,smn",
    "FIELD17":"660013",
    "FIELD18":"NO,RU,SE",
    "FIELD19":""
  },
  {
    "FIELD1":"FJ",
    "FIELD2":"FJI",
    "FIELD3":"242",
    "FIELD4":"FJ",
    "FIELD5":"Fiji",
    "FIELD6":"Suva",
    "FIELD7":"18270",
    "FIELD8":"875983",
    "FIELD9":"OC",
    "FIELD10":".fj",
    "FIELD11":"FJD",
    "FIELD12":"Dollar",
    "FIELD13":"679",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-FJ,fj",
    "FIELD17":"2205218",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"FK",
    "FIELD2":"FLK",
    "FIELD3":"238",
    "FIELD4":"FK",
    "FIELD5":"Falkland Islands",
    "FIELD6":"Stanley",
    "FIELD7":"12173",
    "FIELD8":"2638",
    "FIELD9":"SA",
    "FIELD10":".fk",
    "FIELD11":"FKP",
    "FIELD12":"Pound",
    "FIELD13":"500",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-FK",
    "FIELD17":"3474414",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"FM",
    "FIELD2":"FSM",
    "FIELD3":"583",
    "FIELD4":"FM",
    "FIELD5":"Micronesia",
    "FIELD6":"Palikir",
    "FIELD7":"702",
    "FIELD8":"107708",
    "FIELD9":"OC",
    "FIELD10":".fm",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"691",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"en-FM,chk,pon,yap,kos,uli,woe,nkr,kpg",
    "FIELD17":"2081918",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"FO",
    "FIELD2":"FRO",
    "FIELD3":"234",
    "FIELD4":"FO",
    "FIELD5":"Faroe Islands",
    "FIELD6":"Torshavn",
    "FIELD7":"1399",
    "FIELD8":"48228",
    "FIELD9":"EU",
    "FIELD10":".fo",
    "FIELD11":"DKK",
    "FIELD12":"Krone",
    "FIELD13":"298",
    "FIELD14":"FO-###",
    "FIELD15":"^(?:FO)*(\\d{3})$",
    "FIELD16":"fo,da-FO",
    "FIELD17":"2622320",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"FR",
    "FIELD2":"FRA",
    "FIELD3":"250",
    "FIELD4":"FR",
    "FIELD5":"France",
    "FIELD6":"Paris",
    "FIELD7":"547030",
    "FIELD8":"64768389",
    "FIELD9":"EU",
    "FIELD10":".fr",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"33",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-FR,frp,br,co,ca,eu,oc",
    "FIELD17":"3017382",
    "FIELD18":"CH,DE,BE,LU,IT,AD,MC,ES",
    "FIELD19":""
  },
  {
    "FIELD1":"GA",
    "FIELD2":"GAB",
    "FIELD3":"266",
    "FIELD4":"GB",
    "FIELD5":"Gabon",
    "FIELD6":"Libreville",
    "FIELD7":"267667",
    "FIELD8":"1545255",
    "FIELD9":"AF",
    "FIELD10":".ga",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"241",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-GA",
    "FIELD17":"2400553",
    "FIELD18":"CM,GQ,CG",
    "FIELD19":""
  },
  {
    "FIELD1":"GB",
    "FIELD2":"GBR",
    "FIELD3":"826",
    "FIELD4":"UK",
    "FIELD5":"United Kingdom",
    "FIELD6":"London",
    "FIELD7":"244820",
    "FIELD8":"62348447",
    "FIELD9":"EU",
    "FIELD10":".uk",
    "FIELD11":"GBP",
    "FIELD12":"Pound",
    "FIELD13":"44",
    "FIELD14":"@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    "FIELD15":"^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
    "FIELD16":"en-GB,cy-GB,gd",
    "FIELD17":"2635167",
    "FIELD18":"IE",
    "FIELD19":""
  },
  {
    "FIELD1":"GD",
    "FIELD2":"GRD",
    "FIELD3":"308",
    "FIELD4":"GJ",
    "FIELD5":"Grenada",
    "FIELD6":"St. George's",
    "FIELD7":"344",
    "FIELD8":"107818",
    "FIELD9":"NA",
    "FIELD10":".gd",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-473",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-GD",
    "FIELD17":"3580239",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GE",
    "FIELD2":"GEO",
    "FIELD3":"268",
    "FIELD4":"GG",
    "FIELD5":"Georgia",
    "FIELD6":"Tbilisi",
    "FIELD7":"69700",
    "FIELD8":"4630000",
    "FIELD9":"AS",
    "FIELD10":".ge",
    "FIELD11":"GEL",
    "FIELD12":"Lari",
    "FIELD13":"995",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"ka,ru,hy,az",
    "FIELD17":"614540",
    "FIELD18":"AM,AZ,TR,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"GF",
    "FIELD2":"GUF",
    "FIELD3":"254",
    "FIELD4":"FG",
    "FIELD5":"French Guiana",
    "FIELD6":"Cayenne",
    "FIELD7":"91000",
    "FIELD8":"195506",
    "FIELD9":"SA",
    "FIELD10":".gf",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"594",
    "FIELD14":"#####",
    "FIELD15":"^((97|98)3\\d{2})$",
    "FIELD16":"fr-GF",
    "FIELD17":"3381670",
    "FIELD18":"SR,BR",
    "FIELD19":""
  },
  {
    "FIELD1":"GG",
    "FIELD2":"GGY",
    "FIELD3":"831",
    "FIELD4":"GK",
    "FIELD5":"Guernsey",
    "FIELD6":"St Peter Port",
    "FIELD7":"78",
    "FIELD8":"65228",
    "FIELD9":"EU",
    "FIELD10":".gg",
    "FIELD11":"GBP",
    "FIELD12":"Pound",
    "FIELD13":"+44-1481",
    "FIELD14":"@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    "FIELD15":"^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
    "FIELD16":"en,fr",
    "FIELD17":"3042362",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GH",
    "FIELD2":"GHA",
    "FIELD3":"288",
    "FIELD4":"GH",
    "FIELD5":"Ghana",
    "FIELD6":"Accra",
    "FIELD7":"239460",
    "FIELD8":"24339838",
    "FIELD9":"AF",
    "FIELD10":".gh",
    "FIELD11":"GHS",
    "FIELD12":"Cedi",
    "FIELD13":"233",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-GH,ak,ee,tw",
    "FIELD17":"2300660",
    "FIELD18":"CI,TG,BF",
    "FIELD19":""
  },
  {
    "FIELD1":"GI",
    "FIELD2":"GIB",
    "FIELD3":"292",
    "FIELD4":"GI",
    "FIELD5":"Gibraltar",
    "FIELD6":"Gibraltar",
    "FIELD7":"6.5",
    "FIELD8":"27884",
    "FIELD9":"EU",
    "FIELD10":".gi",
    "FIELD11":"GIP",
    "FIELD12":"Pound",
    "FIELD13":"350",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-GI,es,it,pt",
    "FIELD17":"2411586",
    "FIELD18":"ES",
    "FIELD19":""
  },
  {
    "FIELD1":"GL",
    "FIELD2":"GRL",
    "FIELD3":"304",
    "FIELD4":"GL",
    "FIELD5":"Greenland",
    "FIELD6":"Nuuk",
    "FIELD7":"2166086",
    "FIELD8":"56375",
    "FIELD9":"NA",
    "FIELD10":".gl",
    "FIELD11":"DKK",
    "FIELD12":"Krone",
    "FIELD13":"299",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"kl,da-GL,en",
    "FIELD17":"3425505",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GM",
    "FIELD2":"GMB",
    "FIELD3":"270",
    "FIELD4":"GA",
    "FIELD5":"Gambia",
    "FIELD6":"Banjul",
    "FIELD7":"11300",
    "FIELD8":"1593256",
    "FIELD9":"AF",
    "FIELD10":".gm",
    "FIELD11":"GMD",
    "FIELD12":"Dalasi",
    "FIELD13":"220",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-GM,mnk,wof,wo,ff",
    "FIELD17":"2413451",
    "FIELD18":"SN",
    "FIELD19":""
  },
  {
    "FIELD1":"GN",
    "FIELD2":"GIN",
    "FIELD3":"324",
    "FIELD4":"GV",
    "FIELD5":"Guinea",
    "FIELD6":"Conakry",
    "FIELD7":"245857",
    "FIELD8":"10324025",
    "FIELD9":"AF",
    "FIELD10":".gn",
    "FIELD11":"GNF",
    "FIELD12":"Franc",
    "FIELD13":"224",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-GN",
    "FIELD17":"2420477",
    "FIELD18":"LR,SN,SL,CI,GW,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"GP",
    "FIELD2":"GLP",
    "FIELD3":"312",
    "FIELD4":"GP",
    "FIELD5":"Guadeloupe",
    "FIELD6":"Basse-Terre",
    "FIELD7":"1780",
    "FIELD8":"443000",
    "FIELD9":"NA",
    "FIELD10":".gp",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"590",
    "FIELD14":"#####",
    "FIELD15":"^((97|98)\\d{3})$",
    "FIELD16":"fr-GP",
    "FIELD17":"3579143",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GQ",
    "FIELD2":"GNQ",
    "FIELD3":"226",
    "FIELD4":"EK",
    "FIELD5":"Equatorial Guinea",
    "FIELD6":"Malabo",
    "FIELD7":"28051",
    "FIELD8":"1014999",
    "FIELD9":"AF",
    "FIELD10":".gq",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"240",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"es-GQ,fr",
    "FIELD17":"2309096",
    "FIELD18":"GA,CM",
    "FIELD19":""
  },
  {
    "FIELD1":"GR",
    "FIELD2":"GRC",
    "FIELD3":"300",
    "FIELD4":"GR",
    "FIELD5":"Greece",
    "FIELD6":"Athens",
    "FIELD7":"131940",
    "FIELD8":"11000000",
    "FIELD9":"EU",
    "FIELD10":".gr",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"30",
    "FIELD14":"### ##",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"el-GR,en,fr",
    "FIELD17":"390903",
    "FIELD18":"AL,MK,TR,BG",
    "FIELD19":""
  },
  {
    "FIELD1":"GS",
    "FIELD2":"SGS",
    "FIELD3":"239",
    "FIELD4":"SX",
    "FIELD5":"South Georgia and the South Sandwich Islands",
    "FIELD6":"Grytviken",
    "FIELD7":"3903",
    "FIELD8":"30",
    "FIELD9":"AN",
    "FIELD10":".gs",
    "FIELD11":"GBP",
    "FIELD12":"Pound",
    "FIELD13":"",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en",
    "FIELD17":"3474415",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GT",
    "FIELD2":"GTM",
    "FIELD3":"320",
    "FIELD4":"GT",
    "FIELD5":"Guatemala",
    "FIELD6":"Guatemala City",
    "FIELD7":"108890",
    "FIELD8":"13550440",
    "FIELD9":"NA",
    "FIELD10":".gt",
    "FIELD11":"GTQ",
    "FIELD12":"Quetzal",
    "FIELD13":"502",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"es-GT",
    "FIELD17":"3595528",
    "FIELD18":"MX,HN,BZ,SV",
    "FIELD19":""
  },
  {
    "FIELD1":"GU",
    "FIELD2":"GUM",
    "FIELD3":"316",
    "FIELD4":"GQ",
    "FIELD5":"Guam",
    "FIELD6":"Hagatna",
    "FIELD7":"549",
    "FIELD8":"159358",
    "FIELD9":"OC",
    "FIELD10":".gu",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-671",
    "FIELD14":"969##",
    "FIELD15":"^(969\\d{2})$",
    "FIELD16":"en-GU,ch-GU",
    "FIELD17":"4043988",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"GW",
    "FIELD2":"GNB",
    "FIELD3":"624",
    "FIELD4":"PU",
    "FIELD5":"Guinea-Bissau",
    "FIELD6":"Bissau",
    "FIELD7":"36120",
    "FIELD8":"1565126",
    "FIELD9":"AF",
    "FIELD10":".gw",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"245",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"pt-GW,pov",
    "FIELD17":"2372248",
    "FIELD18":"SN,GN",
    "FIELD19":""
  },
  {
    "FIELD1":"GY",
    "FIELD2":"GUY",
    "FIELD3":"328",
    "FIELD4":"GY",
    "FIELD5":"Guyana",
    "FIELD6":"Georgetown",
    "FIELD7":"214970",
    "FIELD8":"748486",
    "FIELD9":"SA",
    "FIELD10":".gy",
    "FIELD11":"GYD",
    "FIELD12":"Dollar",
    "FIELD13":"592",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-GY",
    "FIELD17":"3378535",
    "FIELD18":"SR,BR,VE",
    "FIELD19":""
  },
  {
    "FIELD1":"HK",
    "FIELD2":"HKG",
    "FIELD3":"344",
    "FIELD4":"HK",
    "FIELD5":"Hong Kong",
    "FIELD6":"Hong Kong",
    "FIELD7":"1092",
    "FIELD8":"6898686",
    "FIELD9":"AS",
    "FIELD10":".hk",
    "FIELD11":"HKD",
    "FIELD12":"Dollar",
    "FIELD13":"852",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"zh-HK,yue,zh,en",
    "FIELD17":"1819730",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"HM",
    "FIELD2":"HMD",
    "FIELD3":"334",
    "FIELD4":"HM",
    "FIELD5":"Heard Island and McDonald Islands",
    "FIELD6":"",
    "FIELD7":"412",
    "FIELD8":"0",
    "FIELD9":"AN",
    "FIELD10":".hm",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":" ",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"",
    "FIELD17":"1547314",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"HN",
    "FIELD2":"HND",
    "FIELD3":"340",
    "FIELD4":"HO",
    "FIELD5":"Honduras",
    "FIELD6":"Tegucigalpa",
    "FIELD7":"112090",
    "FIELD8":"7989415",
    "FIELD9":"NA",
    "FIELD10":".hn",
    "FIELD11":"HNL",
    "FIELD12":"Lempira",
    "FIELD13":"504",
    "FIELD14":"@@####",
    "FIELD15":"^([A-Z]{2}\\d{4})$",
    "FIELD16":"es-HN",
    "FIELD17":"3608932",
    "FIELD18":"GT,NI,SV",
    "FIELD19":""
  },
  {
    "FIELD1":"HR",
    "FIELD2":"HRV",
    "FIELD3":"191",
    "FIELD4":"HR",
    "FIELD5":"Croatia",
    "FIELD6":"Zagreb",
    "FIELD7":"56542",
    "FIELD8":"4491000",
    "FIELD9":"EU",
    "FIELD10":".hr",
    "FIELD11":"HRK",
    "FIELD12":"Kuna",
    "FIELD13":"385",
    "FIELD14":"#####",
    "FIELD15":"^(?:HR)*(\\d{5})$",
    "FIELD16":"hr-HR,sr",
    "FIELD17":"3202326",
    "FIELD18":"HU,SI,BA,ME,RS",
    "FIELD19":""
  },
  {
    "FIELD1":"HT",
    "FIELD2":"HTI",
    "FIELD3":"332",
    "FIELD4":"HA",
    "FIELD5":"Haiti",
    "FIELD6":"Port-au-Prince",
    "FIELD7":"27750",
    "FIELD8":"9648924",
    "FIELD9":"NA",
    "FIELD10":".ht",
    "FIELD11":"HTG",
    "FIELD12":"Gourde",
    "FIELD13":"509",
    "FIELD14":"HT####",
    "FIELD15":"^(?:HT)*(\\d{4})$",
    "FIELD16":"ht,fr-HT",
    "FIELD17":"3723988",
    "FIELD18":"DO",
    "FIELD19":""
  },
  {
    "FIELD1":"HU",
    "FIELD2":"HUN",
    "FIELD3":"348",
    "FIELD4":"HU",
    "FIELD5":"Hungary",
    "FIELD6":"Budapest",
    "FIELD7":"93030",
    "FIELD8":"9982000",
    "FIELD9":"EU",
    "FIELD10":".hu",
    "FIELD11":"HUF",
    "FIELD12":"Forint",
    "FIELD13":"36",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"hu-HU",
    "FIELD17":"719819",
    "FIELD18":"SK,SI,RO,UA,HR,AT,RS",
    "FIELD19":""
  },
  {
    "FIELD1":"ID",
    "FIELD2":"IDN",
    "FIELD3":"360",
    "FIELD4":"ID",
    "FIELD5":"Indonesia",
    "FIELD6":"Jakarta",
    "FIELD7":"1919440",
    "FIELD8":"242968342",
    "FIELD9":"AS",
    "FIELD10":".id",
    "FIELD11":"IDR",
    "FIELD12":"Rupiah",
    "FIELD13":"62",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"id,en,nl,jv",
    "FIELD17":"1643084",
    "FIELD18":"PG,TL,MY",
    "FIELD19":""
  },
  {
    "FIELD1":"IE",
    "FIELD2":"IRL",
    "FIELD3":"372",
    "FIELD4":"EI",
    "FIELD5":"Ireland",
    "FIELD6":"Dublin",
    "FIELD7":"70280",
    "FIELD8":"4622917",
    "FIELD9":"EU",
    "FIELD10":".ie",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"353",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-IE,ga-IE",
    "FIELD17":"2963597",
    "FIELD18":"GB",
    "FIELD19":""
  },
  {
    "FIELD1":"IL",
    "FIELD2":"ISR",
    "FIELD3":"376",
    "FIELD4":"IS",
    "FIELD5":"Israel",
    "FIELD6":"Jerusalem",
    "FIELD7":"20770",
    "FIELD8":"7353985",
    "FIELD9":"AS",
    "FIELD10":".il",
    "FIELD11":"ILS",
    "FIELD12":"Shekel",
    "FIELD13":"972",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"he,ar-IL,en-IL,",
    "FIELD17":"294640",
    "FIELD18":"SY,JO,LB,EG,PS",
    "FIELD19":""
  },
  {
    "FIELD1":"IM",
    "FIELD2":"IMN",
    "FIELD3":"833",
    "FIELD4":"IM",
    "FIELD5":"Isle of Man",
    "FIELD6":"Douglas, Isle of Man",
    "FIELD7":"572",
    "FIELD8":"75049",
    "FIELD9":"EU",
    "FIELD10":".im",
    "FIELD11":"GBP",
    "FIELD12":"Pound",
    "FIELD13":"+44-1624",
    "FIELD14":"@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    "FIELD15":"^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
    "FIELD16":"en,gv",
    "FIELD17":"3042225",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"IN",
    "FIELD2":"IND",
    "FIELD3":"356",
    "FIELD4":"IN",
    "FIELD5":"India",
    "FIELD6":"New Delhi",
    "FIELD7":"3287590",
    "FIELD8":"1173108018",
    "FIELD9":"AS",
    "FIELD10":".in",
    "FIELD11":"INR",
    "FIELD12":"Rupee",
    "FIELD13":"91",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"en-IN,hi,bn,te,mr,ta,ur,gu,kn,ml,or,pa,as,bh,sat,ks,ne,sd,kok,doi,mni,sit,sa,fr,lus,inc",
    "FIELD17":"1269750",
    "FIELD18":"CN,NP,MM,BT,PK,BD",
    "FIELD19":""
  },
  {
    "FIELD1":"IO",
    "FIELD2":"IOT",
    "FIELD3":"086",
    "FIELD4":"IO",
    "FIELD5":"British Indian Ocean Territory",
    "FIELD6":"Diego Garcia",
    "FIELD7":"60",
    "FIELD8":"4000",
    "FIELD9":"AS",
    "FIELD10":".io",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"246",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-IO",
    "FIELD17":"1282588",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"IQ",
    "FIELD2":"IRQ",
    "FIELD3":"368",
    "FIELD4":"IZ",
    "FIELD5":"Iraq",
    "FIELD6":"Baghdad",
    "FIELD7":"437072",
    "FIELD8":"29671605",
    "FIELD9":"AS",
    "FIELD10":".iq",
    "FIELD11":"IQD",
    "FIELD12":"Dinar",
    "FIELD13":"964",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-IQ,ku,hy",
    "FIELD17":"99237",
    "FIELD18":"SY,SA,IR,JO,TR,KW",
    "FIELD19":""
  },
  {
    "FIELD1":"IR",
    "FIELD2":"IRN",
    "FIELD3":"364",
    "FIELD4":"IR",
    "FIELD5":"Iran",
    "FIELD6":"Tehran",
    "FIELD7":"1648000",
    "FIELD8":"76923300",
    "FIELD9":"AS",
    "FIELD10":".ir",
    "FIELD11":"IRR",
    "FIELD12":"Rial",
    "FIELD13":"98",
    "FIELD14":"##########",
    "FIELD15":"^(\\d{10})$",
    "FIELD16":"fa-IR,ku",
    "FIELD17":"130758",
    "FIELD18":"TM,AF,IQ,AM,PK,AZ,TR",
    "FIELD19":""
  },
  {
    "FIELD1":"IS",
    "FIELD2":"ISL",
    "FIELD3":"352",
    "FIELD4":"IC",
    "FIELD5":"Iceland",
    "FIELD6":"Reykjavik",
    "FIELD7":"103000",
    "FIELD8":"308910",
    "FIELD9":"EU",
    "FIELD10":".is",
    "FIELD11":"ISK",
    "FIELD12":"Krona",
    "FIELD13":"354",
    "FIELD14":"###",
    "FIELD15":"^(\\d{3})$",
    "FIELD16":"is,en,de,da,sv,no",
    "FIELD17":"2629691",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"IT",
    "FIELD2":"ITA",
    "FIELD3":"380",
    "FIELD4":"IT",
    "FIELD5":"Italy",
    "FIELD6":"Rome",
    "FIELD7":"301230",
    "FIELD8":"60340328",
    "FIELD9":"EU",
    "FIELD10":".it",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"39",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"it-IT,de-IT,fr-IT,sc,ca,co,sl",
    "FIELD17":"3175395",
    "FIELD18":"CH,VA,SI,SM,FR,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"JE",
    "FIELD2":"JEY",
    "FIELD3":"832",
    "FIELD4":"JE",
    "FIELD5":"Jersey",
    "FIELD6":"Saint Helier",
    "FIELD7":"116",
    "FIELD8":"90812",
    "FIELD9":"EU",
    "FIELD10":".je",
    "FIELD11":"GBP",
    "FIELD12":"Pound",
    "FIELD13":"+44-1534",
    "FIELD14":"@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    "FIELD15":"^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
    "FIELD16":"en,pt",
    "FIELD17":"3042142",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"JM",
    "FIELD2":"JAM",
    "FIELD3":"388",
    "FIELD4":"JM",
    "FIELD5":"Jamaica",
    "FIELD6":"Kingston",
    "FIELD7":"10991",
    "FIELD8":"2847232",
    "FIELD9":"NA",
    "FIELD10":".jm",
    "FIELD11":"JMD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-876",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-JM",
    "FIELD17":"3489940",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"JO",
    "FIELD2":"JOR",
    "FIELD3":"400",
    "FIELD4":"JO",
    "FIELD5":"Jordan",
    "FIELD6":"Amman",
    "FIELD7":"92300",
    "FIELD8":"6407085",
    "FIELD9":"AS",
    "FIELD10":".jo",
    "FIELD11":"JOD",
    "FIELD12":"Dinar",
    "FIELD13":"962",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-JO,en",
    "FIELD17":"248816",
    "FIELD18":"SY,SA,IQ,IL,PS",
    "FIELD19":""
  },
  {
    "FIELD1":"JP",
    "FIELD2":"JPN",
    "FIELD3":"392",
    "FIELD4":"JA",
    "FIELD5":"Japan",
    "FIELD6":"Tokyo",
    "FIELD7":"377835",
    "FIELD8":"127288000",
    "FIELD9":"AS",
    "FIELD10":".jp",
    "FIELD11":"JPY",
    "FIELD12":"Yen",
    "FIELD13":"81",
    "FIELD14":"###-####",
    "FIELD15":"^(\\d{7})$",
    "FIELD16":"ja",
    "FIELD17":"1861060",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"KE",
    "FIELD2":"KEN",
    "FIELD3":"404",
    "FIELD4":"KE",
    "FIELD5":"Kenya",
    "FIELD6":"Nairobi",
    "FIELD7":"582650",
    "FIELD8":"40046566",
    "FIELD9":"AF",
    "FIELD10":".ke",
    "FIELD11":"KES",
    "FIELD12":"Shilling",
    "FIELD13":"254",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"en-KE,sw-KE",
    "FIELD17":"192950",
    "FIELD18":"ET,TZ,SS,SO,UG",
    "FIELD19":""
  },
  {
    "FIELD1":"KG",
    "FIELD2":"KGZ",
    "FIELD3":"417",
    "FIELD4":"KG",
    "FIELD5":"Kyrgyzstan",
    "FIELD6":"Bishkek",
    "FIELD7":"198500",
    "FIELD8":"5508626",
    "FIELD9":"AS",
    "FIELD10":".kg",
    "FIELD11":"KGS",
    "FIELD12":"Som",
    "FIELD13":"996",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"ky,uz,ru",
    "FIELD17":"1527747",
    "FIELD18":"CN,TJ,UZ,KZ",
    "FIELD19":""
  },
  {
    "FIELD1":"KH",
    "FIELD2":"KHM",
    "FIELD3":"116",
    "FIELD4":"CB",
    "FIELD5":"Cambodia",
    "FIELD6":"Phnom Penh",
    "FIELD7":"181040",
    "FIELD8":"14453680",
    "FIELD9":"AS",
    "FIELD10":".kh",
    "FIELD11":"KHR",
    "FIELD12":"Riels",
    "FIELD13":"855",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"km,fr,en",
    "FIELD17":"1831722",
    "FIELD18":"LA,TH,VN",
    "FIELD19":""
  },
  {
    "FIELD1":"KI",
    "FIELD2":"KIR",
    "FIELD3":"296",
    "FIELD4":"KR",
    "FIELD5":"Kiribati",
    "FIELD6":"Tarawa",
    "FIELD7":"811",
    "FIELD8":"92533",
    "FIELD9":"OC",
    "FIELD10":".ki",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"686",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-KI,gil",
    "FIELD17":"4030945",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"KM",
    "FIELD2":"COM",
    "FIELD3":"174",
    "FIELD4":"CN",
    "FIELD5":"Comoros",
    "FIELD6":"Moroni",
    "FIELD7":"2170",
    "FIELD8":"773407",
    "FIELD9":"AF",
    "FIELD10":".km",
    "FIELD11":"KMF",
    "FIELD12":"Franc",
    "FIELD13":"269",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar,fr-KM",
    "FIELD17":"921929",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"KN",
    "FIELD2":"KNA",
    "FIELD3":"659",
    "FIELD4":"SC",
    "FIELD5":"Saint Kitts and Nevis",
    "FIELD6":"Basseterre",
    "FIELD7":"261",
    "FIELD8":"51134",
    "FIELD9":"NA",
    "FIELD10":".kn",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-869",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-KN",
    "FIELD17":"3575174",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"KP",
    "FIELD2":"PRK",
    "FIELD3":"408",
    "FIELD4":"KN",
    "FIELD5":"North Korea",
    "FIELD6":"Pyongyang",
    "FIELD7":"120540",
    "FIELD8":"22912177",
    "FIELD9":"AS",
    "FIELD10":".kp",
    "FIELD11":"KPW",
    "FIELD12":"Won",
    "FIELD13":"850",
    "FIELD14":"###-###",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"ko-KP",
    "FIELD17":"1873107",
    "FIELD18":"CN,KR,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"KR",
    "FIELD2":"KOR",
    "FIELD3":"410",
    "FIELD4":"KS",
    "FIELD5":"South Korea",
    "FIELD6":"Seoul",
    "FIELD7":"98480",
    "FIELD8":"48422644",
    "FIELD9":"AS",
    "FIELD10":".kr",
    "FIELD11":"KRW",
    "FIELD12":"Won",
    "FIELD13":"82",
    "FIELD14":"SEOUL ###-###",
    "FIELD15":"^(?:SEOUL)*(\\d{6})$",
    "FIELD16":"ko-KR,en",
    "FIELD17":"1835841",
    "FIELD18":"KP",
    "FIELD19":""
  },
  {
    "FIELD1":"XK",
    "FIELD2":"XKX",
    "FIELD3":"0",
    "FIELD4":"KV",
    "FIELD5":"Kosovo",
    "FIELD6":"Pristina",
    "FIELD7":"10908",
    "FIELD8":"1800000",
    "FIELD9":"EU",
    "FIELD10":"",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"sq,sr",
    "FIELD17":"831053",
    "FIELD18":"RS,AL,MK,ME",
    "FIELD19":""
  },
  {
    "FIELD1":"KW",
    "FIELD2":"KWT",
    "FIELD3":"414",
    "FIELD4":"KU",
    "FIELD5":"Kuwait",
    "FIELD6":"Kuwait City",
    "FIELD7":"17820",
    "FIELD8":"2789132",
    "FIELD9":"AS",
    "FIELD10":".kw",
    "FIELD11":"KWD",
    "FIELD12":"Dinar",
    "FIELD13":"965",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-KW,en",
    "FIELD17":"285570",
    "FIELD18":"SA,IQ",
    "FIELD19":""
  },
  {
    "FIELD1":"KY",
    "FIELD2":"CYM",
    "FIELD3":"136",
    "FIELD4":"CJ",
    "FIELD5":"Cayman Islands",
    "FIELD6":"George Town",
    "FIELD7":"262",
    "FIELD8":"44270",
    "FIELD9":"NA",
    "FIELD10":".ky",
    "FIELD11":"KYD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-345",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-KY",
    "FIELD17":"3580718",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"KZ",
    "FIELD2":"KAZ",
    "FIELD3":"398",
    "FIELD4":"KZ",
    "FIELD5":"Kazakhstan",
    "FIELD6":"Astana",
    "FIELD7":"2717300",
    "FIELD8":"15340000",
    "FIELD9":"AS",
    "FIELD10":".kz",
    "FIELD11":"KZT",
    "FIELD12":"Tenge",
    "FIELD13":"7",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"kk,ru",
    "FIELD17":"1522867",
    "FIELD18":"TM,CN,KG,UZ,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"LA",
    "FIELD2":"LAO",
    "FIELD3":"418",
    "FIELD4":"LA",
    "FIELD5":"Laos",
    "FIELD6":"Vientiane",
    "FIELD7":"236800",
    "FIELD8":"6368162",
    "FIELD9":"AS",
    "FIELD10":".la",
    "FIELD11":"LAK",
    "FIELD12":"Kip",
    "FIELD13":"856",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"lo,fr,en",
    "FIELD17":"1655842",
    "FIELD18":"CN,MM,KH,TH,VN",
    "FIELD19":""
  },
  {
    "FIELD1":"LB",
    "FIELD2":"LBN",
    "FIELD3":"422",
    "FIELD4":"LE",
    "FIELD5":"Lebanon",
    "FIELD6":"Beirut",
    "FIELD7":"10400",
    "FIELD8":"4125247",
    "FIELD9":"AS",
    "FIELD10":".lb",
    "FIELD11":"LBP",
    "FIELD12":"Pound",
    "FIELD13":"961",
    "FIELD14":"#### ####|####",
    "FIELD15":"^(\\d{4}(\\d{4})?)$",
    "FIELD16":"ar-LB,fr-LB,en,hy",
    "FIELD17":"272103",
    "FIELD18":"SY,IL",
    "FIELD19":""
  },
  {
    "FIELD1":"LC",
    "FIELD2":"LCA",
    "FIELD3":"662",
    "FIELD4":"ST",
    "FIELD5":"Saint Lucia",
    "FIELD6":"Castries",
    "FIELD7":"616",
    "FIELD8":"160922",
    "FIELD9":"NA",
    "FIELD10":".lc",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-758",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-LC",
    "FIELD17":"3576468",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"LI",
    "FIELD2":"LIE",
    "FIELD3":"438",
    "FIELD4":"LS",
    "FIELD5":"Liechtenstein",
    "FIELD6":"Vaduz",
    "FIELD7":"160",
    "FIELD8":"35000",
    "FIELD9":"EU",
    "FIELD10":".li",
    "FIELD11":"CHF",
    "FIELD12":"Franc",
    "FIELD13":"423",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"de-LI",
    "FIELD17":"3042058",
    "FIELD18":"CH,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"LK",
    "FIELD2":"LKA",
    "FIELD3":"144",
    "FIELD4":"CE",
    "FIELD5":"Sri Lanka",
    "FIELD6":"Colombo",
    "FIELD7":"65610",
    "FIELD8":"21513990",
    "FIELD9":"AS",
    "FIELD10":".lk",
    "FIELD11":"LKR",
    "FIELD12":"Rupee",
    "FIELD13":"94",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"si,ta,en",
    "FIELD17":"1227603",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"LR",
    "FIELD2":"LBR",
    "FIELD3":"430",
    "FIELD4":"LI",
    "FIELD5":"Liberia",
    "FIELD6":"Monrovia",
    "FIELD7":"111370",
    "FIELD8":"3685076",
    "FIELD9":"AF",
    "FIELD10":".lr",
    "FIELD11":"LRD",
    "FIELD12":"Dollar",
    "FIELD13":"231",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"en-LR",
    "FIELD17":"2275384",
    "FIELD18":"SL,CI,GN",
    "FIELD19":""
  },
  {
    "FIELD1":"LS",
    "FIELD2":"LSO",
    "FIELD3":"426",
    "FIELD4":"LT",
    "FIELD5":"Lesotho",
    "FIELD6":"Maseru",
    "FIELD7":"30355",
    "FIELD8":"1919552",
    "FIELD9":"AF",
    "FIELD10":".ls",
    "FIELD11":"LSL",
    "FIELD12":"Loti",
    "FIELD13":"266",
    "FIELD14":"###",
    "FIELD15":"^(\\d{3})$",
    "FIELD16":"en-LS,st,zu,xh",
    "FIELD17":"932692",
    "FIELD18":"ZA",
    "FIELD19":""
  },
  {
    "FIELD1":"LT",
    "FIELD2":"LTU",
    "FIELD3":"440",
    "FIELD4":"LH",
    "FIELD5":"Lithuania",
    "FIELD6":"Vilnius",
    "FIELD7":"65200",
    "FIELD8":"2944459",
    "FIELD9":"EU",
    "FIELD10":".lt",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"370",
    "FIELD14":"LT-#####",
    "FIELD15":"^(?:LT)*(\\d{5})$",
    "FIELD16":"lt,ru,pl",
    "FIELD17":"597427",
    "FIELD18":"PL,BY,RU,LV",
    "FIELD19":""
  },
  {
    "FIELD1":"LU",
    "FIELD2":"LUX",
    "FIELD3":"442",
    "FIELD4":"LU",
    "FIELD5":"Luxembourg",
    "FIELD6":"Luxembourg",
    "FIELD7":"2586",
    "FIELD8":"497538",
    "FIELD9":"EU",
    "FIELD10":".lu",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"352",
    "FIELD14":"L-####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"lb,de-LU,fr-LU",
    "FIELD17":"2960313",
    "FIELD18":"DE,BE,FR",
    "FIELD19":""
  },
  {
    "FIELD1":"LV",
    "FIELD2":"LVA",
    "FIELD3":"428",
    "FIELD4":"LG",
    "FIELD5":"Latvia",
    "FIELD6":"Riga",
    "FIELD7":"64589",
    "FIELD8":"2217969",
    "FIELD9":"EU",
    "FIELD10":".lv",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"371",
    "FIELD14":"LV-####",
    "FIELD15":"^(?:LV)*(\\d{4})$",
    "FIELD16":"lv,ru,lt",
    "FIELD17":"458258",
    "FIELD18":"LT,EE,BY,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"LY",
    "FIELD2":"LBY",
    "FIELD3":"434",
    "FIELD4":"LY",
    "FIELD5":"Libya",
    "FIELD6":"Tripolis",
    "FIELD7":"1759540",
    "FIELD8":"6461454",
    "FIELD9":"AF",
    "FIELD10":".ly",
    "FIELD11":"LYD",
    "FIELD12":"Dinar",
    "FIELD13":"218",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-LY,it,en",
    "FIELD17":"2215636",
    "FIELD18":"TD,NE,DZ,SD,TN,EG",
    "FIELD19":""
  },
  {
    "FIELD1":"MA",
    "FIELD2":"MAR",
    "FIELD3":"504",
    "FIELD4":"MO",
    "FIELD5":"Morocco",
    "FIELD6":"Rabat",
    "FIELD7":"446550",
    "FIELD8":"31627428",
    "FIELD9":"AF",
    "FIELD10":".ma",
    "FIELD11":"MAD",
    "FIELD12":"Dirham",
    "FIELD13":"212",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-MA,fr",
    "FIELD17":"2542007",
    "FIELD18":"DZ,EH,ES",
    "FIELD19":""
  },
  {
    "FIELD1":"MC",
    "FIELD2":"MCO",
    "FIELD3":"492",
    "FIELD4":"MN",
    "FIELD5":"Monaco",
    "FIELD6":"Monaco",
    "FIELD7":"1.95",
    "FIELD8":"32965",
    "FIELD9":"EU",
    "FIELD10":".mc",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"377",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-MC,en,it",
    "FIELD17":"2993457",
    "FIELD18":"FR",
    "FIELD19":""
  },
  {
    "FIELD1":"MD",
    "FIELD2":"MDA",
    "FIELD3":"498",
    "FIELD4":"MD",
    "FIELD5":"Moldova",
    "FIELD6":"Chisinau",
    "FIELD7":"33843",
    "FIELD8":"4324000",
    "FIELD9":"EU",
    "FIELD10":".md",
    "FIELD11":"MDL",
    "FIELD12":"Leu",
    "FIELD13":"373",
    "FIELD14":"MD-####",
    "FIELD15":"^(?:MD)*(\\d{4})$",
    "FIELD16":"ro,ru,gag,tr",
    "FIELD17":"617790",
    "FIELD18":"RO,UA",
    "FIELD19":""
  },
  {
    "FIELD1":"ME",
    "FIELD2":"MNE",
    "FIELD3":"499",
    "FIELD4":"MJ",
    "FIELD5":"Montenegro",
    "FIELD6":"Podgorica",
    "FIELD7":"14026",
    "FIELD8":"666730",
    "FIELD9":"EU",
    "FIELD10":".me",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"382",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"sr,hu,bs,sq,hr,rom",
    "FIELD17":"3194884",
    "FIELD18":"AL,HR,BA,RS,XK",
    "FIELD19":""
  },
  {
    "FIELD1":"MF",
    "FIELD2":"MAF",
    "FIELD3":"663",
    "FIELD4":"RN",
    "FIELD5":"Saint Martin",
    "FIELD6":"Marigot",
    "FIELD7":"53",
    "FIELD8":"35925",
    "FIELD9":"NA",
    "FIELD10":".gp",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"590",
    "FIELD14":"### ###",
    "FIELD15":"",
    "FIELD16":"fr",
    "FIELD17":"3578421",
    "FIELD18":"SX",
    "FIELD19":""
  },
  {
    "FIELD1":"MG",
    "FIELD2":"MDG",
    "FIELD3":"450",
    "FIELD4":"MA",
    "FIELD5":"Madagascar",
    "FIELD6":"Antananarivo",
    "FIELD7":"587040",
    "FIELD8":"21281844",
    "FIELD9":"AF",
    "FIELD10":".mg",
    "FIELD11":"MGA",
    "FIELD12":"Ariary",
    "FIELD13":"261",
    "FIELD14":"###",
    "FIELD15":"^(\\d{3})$",
    "FIELD16":"fr-MG,mg",
    "FIELD17":"1062947",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MH",
    "FIELD2":"MHL",
    "FIELD3":"584",
    "FIELD4":"RM",
    "FIELD5":"Marshall Islands",
    "FIELD6":"Majuro",
    "FIELD7":"181.3",
    "FIELD8":"65859",
    "FIELD9":"OC",
    "FIELD10":".mh",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"692",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"mh,en-MH",
    "FIELD17":"2080185",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MK",
    "FIELD2":"MKD",
    "FIELD3":"807",
    "FIELD4":"MK",
    "FIELD5":"Macedonia",
    "FIELD6":"Skopje",
    "FIELD7":"25333",
    "FIELD8":"2062294",
    "FIELD9":"EU",
    "FIELD10":".mk",
    "FIELD11":"MKD",
    "FIELD12":"Denar",
    "FIELD13":"389",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"mk,sq,tr,rmm,sr",
    "FIELD17":"718075",
    "FIELD18":"AL,GR,BG,RS,XK",
    "FIELD19":""
  },
  {
    "FIELD1":"ML",
    "FIELD2":"MLI",
    "FIELD3":"466",
    "FIELD4":"ML",
    "FIELD5":"Mali",
    "FIELD6":"Bamako",
    "FIELD7":"1240000",
    "FIELD8":"13796354",
    "FIELD9":"AF",
    "FIELD10":".ml",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"223",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-ML,bm",
    "FIELD17":"2453866",
    "FIELD18":"SN,NE,DZ,CI,GN,MR,BF",
    "FIELD19":""
  },
  {
    "FIELD1":"MM",
    "FIELD2":"MMR",
    "FIELD3":"104",
    "FIELD4":"BM",
    "FIELD5":"Myanmar",
    "FIELD6":"Nay Pyi Taw",
    "FIELD7":"678500",
    "FIELD8":"53414374",
    "FIELD9":"AS",
    "FIELD10":".mm",
    "FIELD11":"MMK",
    "FIELD12":"Kyat",
    "FIELD13":"95",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"my",
    "FIELD17":"1327865",
    "FIELD18":"CN,LA,TH,BD,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"MN",
    "FIELD2":"MNG",
    "FIELD3":"496",
    "FIELD4":"MG",
    "FIELD5":"Mongolia",
    "FIELD6":"Ulan Bator",
    "FIELD7":"1565000",
    "FIELD8":"3086918",
    "FIELD9":"AS",
    "FIELD10":".mn",
    "FIELD11":"MNT",
    "FIELD12":"Tugrik",
    "FIELD13":"976",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"mn,ru",
    "FIELD17":"2029969",
    "FIELD18":"CN,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"MO",
    "FIELD2":"MAC",
    "FIELD3":"446",
    "FIELD4":"MC",
    "FIELD5":"Macao",
    "FIELD6":"Macao",
    "FIELD7":"254",
    "FIELD8":"449198",
    "FIELD9":"AS",
    "FIELD10":".mo",
    "FIELD11":"MOP",
    "FIELD12":"Pataca",
    "FIELD13":"853",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"zh,zh-MO,pt",
    "FIELD17":"1821275",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MP",
    "FIELD2":"MNP",
    "FIELD3":"580",
    "FIELD4":"CQ",
    "FIELD5":"Northern Mariana Islands",
    "FIELD6":"Saipan",
    "FIELD7":"477",
    "FIELD8":"53883",
    "FIELD9":"OC",
    "FIELD10":".mp",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-670",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fil,tl,zh,ch-MP,en-MP",
    "FIELD17":"4041468",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MQ",
    "FIELD2":"MTQ",
    "FIELD3":"474",
    "FIELD4":"MB",
    "FIELD5":"Martinique",
    "FIELD6":"Fort-de-France",
    "FIELD7":"1100",
    "FIELD8":"432900",
    "FIELD9":"NA",
    "FIELD10":".mq",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"596",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-MQ",
    "FIELD17":"3570311",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MR",
    "FIELD2":"MRT",
    "FIELD3":"478",
    "FIELD4":"MR",
    "FIELD5":"Mauritania",
    "FIELD6":"Nouakchott",
    "FIELD7":"1030700",
    "FIELD8":"3205060",
    "FIELD9":"AF",
    "FIELD10":".mr",
    "FIELD11":"MRO",
    "FIELD12":"Ouguiya",
    "FIELD13":"222",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-MR,fuc,snk,fr,mey,wo",
    "FIELD17":"2378080",
    "FIELD18":"SN,DZ,EH,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"MS",
    "FIELD2":"MSR",
    "FIELD3":"500",
    "FIELD4":"MH",
    "FIELD5":"Montserrat",
    "FIELD6":"Plymouth",
    "FIELD7":"102",
    "FIELD8":"9341",
    "FIELD9":"NA",
    "FIELD10":".ms",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-664",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-MS",
    "FIELD17":"3578097",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MT",
    "FIELD2":"MLT",
    "FIELD3":"470",
    "FIELD4":"MT",
    "FIELD5":"Malta",
    "FIELD6":"Valletta",
    "FIELD7":"316",
    "FIELD8":"403000",
    "FIELD9":"EU",
    "FIELD10":".mt",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"356",
    "FIELD14":"@@@ ###|@@@ ##",
    "FIELD15":"^([A-Z]{3}\\d{2}\\d?)$",
    "FIELD16":"mt,en-MT",
    "FIELD17":"2562770",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MU",
    "FIELD2":"MUS",
    "FIELD3":"480",
    "FIELD4":"MP",
    "FIELD5":"Mauritius",
    "FIELD6":"Port Louis",
    "FIELD7":"2040",
    "FIELD8":"1294104",
    "FIELD9":"AF",
    "FIELD10":".mu",
    "FIELD11":"MUR",
    "FIELD12":"Rupee",
    "FIELD13":"230",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-MU,bho,fr",
    "FIELD17":"934292",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MV",
    "FIELD2":"MDV",
    "FIELD3":"462",
    "FIELD4":"MV",
    "FIELD5":"Maldives",
    "FIELD6":"Male",
    "FIELD7":"300",
    "FIELD8":"395650",
    "FIELD9":"AS",
    "FIELD10":".mv",
    "FIELD11":"MVR",
    "FIELD12":"Rufiyaa",
    "FIELD13":"960",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"dv,en",
    "FIELD17":"1282028",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"MW",
    "FIELD2":"MWI",
    "FIELD3":"454",
    "FIELD4":"MI",
    "FIELD5":"Malawi",
    "FIELD6":"Lilongwe",
    "FIELD7":"118480",
    "FIELD8":"15447500",
    "FIELD9":"AF",
    "FIELD10":".mw",
    "FIELD11":"MWK",
    "FIELD12":"Kwacha",
    "FIELD13":"265",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ny,yao,tum,swk",
    "FIELD17":"927384",
    "FIELD18":"TZ,MZ,ZM",
    "FIELD19":""
  },
  {
    "FIELD1":"MX",
    "FIELD2":"MEX",
    "FIELD3":"484",
    "FIELD4":"MX",
    "FIELD5":"Mexico",
    "FIELD6":"Mexico City",
    "FIELD7":"1972550",
    "FIELD8":"112468855",
    "FIELD9":"NA",
    "FIELD10":".mx",
    "FIELD11":"MXN",
    "FIELD12":"Peso",
    "FIELD13":"52",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"es-MX",
    "FIELD17":"3996063",
    "FIELD18":"GT,US,BZ",
    "FIELD19":""
  },
  {
    "FIELD1":"MY",
    "FIELD2":"MYS",
    "FIELD3":"458",
    "FIELD4":"MY",
    "FIELD5":"Malaysia",
    "FIELD6":"Kuala Lumpur",
    "FIELD7":"329750",
    "FIELD8":"28274729",
    "FIELD9":"AS",
    "FIELD10":".my",
    "FIELD11":"MYR",
    "FIELD12":"Ringgit",
    "FIELD13":"60",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ms-MY,en,zh,ta,te,ml,pa,th",
    "FIELD17":"1733045",
    "FIELD18":"BN,TH,ID",
    "FIELD19":""
  },
  {
    "FIELD1":"MZ",
    "FIELD2":"MOZ",
    "FIELD3":"508",
    "FIELD4":"MZ",
    "FIELD5":"Mozambique",
    "FIELD6":"Maputo",
    "FIELD7":"801590",
    "FIELD8":"22061451",
    "FIELD9":"AF",
    "FIELD10":".mz",
    "FIELD11":"MZN",
    "FIELD12":"Metical",
    "FIELD13":"258",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"pt-MZ,vmw",
    "FIELD17":"1036973",
    "FIELD18":"ZW,TZ,SZ,ZA,ZM,MW",
    "FIELD19":""
  },
  {
    "FIELD1":"NA",
    "FIELD2":"NAM",
    "FIELD3":"516",
    "FIELD4":"WA",
    "FIELD5":"Namibia",
    "FIELD6":"Windhoek",
    "FIELD7":"825418",
    "FIELD8":"2128471",
    "FIELD9":"AF",
    "FIELD10":".na",
    "FIELD11":"NAD",
    "FIELD12":"Dollar",
    "FIELD13":"264",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-NA,af,de,hz,naq",
    "FIELD17":"3355338",
    "FIELD18":"ZA,BW,ZM,AO",
    "FIELD19":""
  },
  {
    "FIELD1":"NC",
    "FIELD2":"NCL",
    "FIELD3":"540",
    "FIELD4":"NC",
    "FIELD5":"New Caledonia",
    "FIELD6":"Noumea",
    "FIELD7":"19060",
    "FIELD8":"216494",
    "FIELD9":"OC",
    "FIELD10":".nc",
    "FIELD11":"XPF",
    "FIELD12":"Franc",
    "FIELD13":"687",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-NC",
    "FIELD17":"2139685",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"NE",
    "FIELD2":"NER",
    "FIELD3":"562",
    "FIELD4":"NG",
    "FIELD5":"Niger",
    "FIELD6":"Niamey",
    "FIELD7":"1267000",
    "FIELD8":"15878271",
    "FIELD9":"AF",
    "FIELD10":".ne",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"227",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"fr-NE,ha,kr,dje",
    "FIELD17":"2440476",
    "FIELD18":"TD,BJ,DZ,LY,BF,NG,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"NF",
    "FIELD2":"NFK",
    "FIELD3":"574",
    "FIELD4":"NF",
    "FIELD5":"Norfolk Island",
    "FIELD6":"Kingston",
    "FIELD7":"34.6",
    "FIELD8":"1828",
    "FIELD9":"OC",
    "FIELD10":".nf",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"672",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"en-NF",
    "FIELD17":"2155115",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"NG",
    "FIELD2":"NGA",
    "FIELD3":"566",
    "FIELD4":"NI",
    "FIELD5":"Nigeria",
    "FIELD6":"Abuja",
    "FIELD7":"923768",
    "FIELD8":"154000000",
    "FIELD9":"AF",
    "FIELD10":".ng",
    "FIELD11":"NGN",
    "FIELD12":"Naira",
    "FIELD13":"234",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"en-NG,ha,yo,ig,ff",
    "FIELD17":"2328926",
    "FIELD18":"TD,NE,BJ,CM",
    "FIELD19":""
  },
  {
    "FIELD1":"NI",
    "FIELD2":"NIC",
    "FIELD3":"558",
    "FIELD4":"NU",
    "FIELD5":"Nicaragua",
    "FIELD6":"Managua",
    "FIELD7":"129494",
    "FIELD8":"5995928",
    "FIELD9":"NA",
    "FIELD10":".ni",
    "FIELD11":"NIO",
    "FIELD12":"Cordoba",
    "FIELD13":"505",
    "FIELD14":"###-###-#",
    "FIELD15":"^(\\d{7})$",
    "FIELD16":"es-NI,en",
    "FIELD17":"3617476",
    "FIELD18":"CR,HN",
    "FIELD19":""
  },
  {
    "FIELD1":"NL",
    "FIELD2":"NLD",
    "FIELD3":"528",
    "FIELD4":"NL",
    "FIELD5":"Netherlands",
    "FIELD6":"Amsterdam",
    "FIELD7":"41526",
    "FIELD8":"16645000",
    "FIELD9":"EU",
    "FIELD10":".nl",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"31",
    "FIELD14":"#### @@",
    "FIELD15":"^(\\d{4}[A-Z]{2})$",
    "FIELD16":"nl-NL,fy-NL",
    "FIELD17":"2750405",
    "FIELD18":"DE,BE",
    "FIELD19":""
  },
  {
    "FIELD1":"NO",
    "FIELD2":"NOR",
    "FIELD3":"578",
    "FIELD4":"NO",
    "FIELD5":"Norway",
    "FIELD6":"Oslo",
    "FIELD7":"324220",
    "FIELD8":"5009150",
    "FIELD9":"EU",
    "FIELD10":".no",
    "FIELD11":"NOK",
    "FIELD12":"Krone",
    "FIELD13":"47",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"no,nb,nn,se,fi",
    "FIELD17":"3144096",
    "FIELD18":"FI,RU,SE",
    "FIELD19":""
  },
  {
    "FIELD1":"NP",
    "FIELD2":"NPL",
    "FIELD3":"524",
    "FIELD4":"NP",
    "FIELD5":"Nepal",
    "FIELD6":"Kathmandu",
    "FIELD7":"140800",
    "FIELD8":"28951852",
    "FIELD9":"AS",
    "FIELD10":".np",
    "FIELD11":"NPR",
    "FIELD12":"Rupee",
    "FIELD13":"977",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ne,en",
    "FIELD17":"1282988",
    "FIELD18":"CN,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"NR",
    "FIELD2":"NRU",
    "FIELD3":"520",
    "FIELD4":"NR",
    "FIELD5":"Nauru",
    "FIELD6":"Yaren",
    "FIELD7":"21",
    "FIELD8":"10065",
    "FIELD9":"OC",
    "FIELD10":".nr",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"674",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"na,en-NR",
    "FIELD17":"2110425",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"NU",
    "FIELD2":"NIU",
    "FIELD3":"570",
    "FIELD4":"NE",
    "FIELD5":"Niue",
    "FIELD6":"Alofi",
    "FIELD7":"260",
    "FIELD8":"2166",
    "FIELD9":"OC",
    "FIELD10":".nu",
    "FIELD11":"NZD",
    "FIELD12":"Dollar",
    "FIELD13":"683",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"niu,en-NU",
    "FIELD17":"4036232",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"NZ",
    "FIELD2":"NZL",
    "FIELD3":"554",
    "FIELD4":"NZ",
    "FIELD5":"New Zealand",
    "FIELD6":"Wellington",
    "FIELD7":"268680",
    "FIELD8":"4252277",
    "FIELD9":"OC",
    "FIELD10":".nz",
    "FIELD11":"NZD",
    "FIELD12":"Dollar",
    "FIELD13":"64",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"en-NZ,mi",
    "FIELD17":"2186224",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"OM",
    "FIELD2":"OMN",
    "FIELD3":"512",
    "FIELD4":"MU",
    "FIELD5":"Oman",
    "FIELD6":"Muscat",
    "FIELD7":"212460",
    "FIELD8":"2967717",
    "FIELD9":"AS",
    "FIELD10":".om",
    "FIELD11":"OMR",
    "FIELD12":"Rial",
    "FIELD13":"968",
    "FIELD14":"###",
    "FIELD15":"^(\\d{3})$",
    "FIELD16":"ar-OM,en,bal,ur",
    "FIELD17":"286963",
    "FIELD18":"SA,YE,AE",
    "FIELD19":""
  },
  {
    "FIELD1":"PA",
    "FIELD2":"PAN",
    "FIELD3":"591",
    "FIELD4":"PM",
    "FIELD5":"Panama",
    "FIELD6":"Panama City",
    "FIELD7":"78200",
    "FIELD8":"3410676",
    "FIELD9":"NA",
    "FIELD10":".pa",
    "FIELD11":"PAB",
    "FIELD12":"Balboa",
    "FIELD13":"507",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"es-PA,en",
    "FIELD17":"3703430",
    "FIELD18":"CR,CO",
    "FIELD19":""
  },
  {
    "FIELD1":"PE",
    "FIELD2":"PER",
    "FIELD3":"604",
    "FIELD4":"PE",
    "FIELD5":"Peru",
    "FIELD6":"Lima",
    "FIELD7":"1285220",
    "FIELD8":"29907003",
    "FIELD9":"SA",
    "FIELD10":".pe",
    "FIELD11":"PEN",
    "FIELD12":"Sol",
    "FIELD13":"51",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"es-PE,qu,ay",
    "FIELD17":"3932488",
    "FIELD18":"EC,CL,BO,BR,CO",
    "FIELD19":""
  },
  {
    "FIELD1":"PF",
    "FIELD2":"PYF",
    "FIELD3":"258",
    "FIELD4":"FP",
    "FIELD5":"French Polynesia",
    "FIELD6":"Papeete",
    "FIELD7":"4167",
    "FIELD8":"270485",
    "FIELD9":"OC",
    "FIELD10":".pf",
    "FIELD11":"XPF",
    "FIELD12":"Franc",
    "FIELD13":"689",
    "FIELD14":"#####",
    "FIELD15":"^((97|98)7\\d{2})$",
    "FIELD16":"fr-PF,ty",
    "FIELD17":"4030656",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PG",
    "FIELD2":"PNG",
    "FIELD3":"598",
    "FIELD4":"PP",
    "FIELD5":"Papua New Guinea",
    "FIELD6":"Port Moresby",
    "FIELD7":"462840",
    "FIELD8":"6064515",
    "FIELD9":"OC",
    "FIELD10":".pg",
    "FIELD11":"PGK",
    "FIELD12":"Kina",
    "FIELD13":"675",
    "FIELD14":"###",
    "FIELD15":"^(\\d{3})$",
    "FIELD16":"en-PG,ho,meu,tpi",
    "FIELD17":"2088628",
    "FIELD18":"ID",
    "FIELD19":""
  },
  {
    "FIELD1":"PH",
    "FIELD2":"PHL",
    "FIELD3":"608",
    "FIELD4":"RP",
    "FIELD5":"Philippines",
    "FIELD6":"Manila",
    "FIELD7":"300000",
    "FIELD8":"99900177",
    "FIELD9":"AS",
    "FIELD10":".ph",
    "FIELD11":"PHP",
    "FIELD12":"Peso",
    "FIELD13":"63",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"tl,en-PH,fil",
    "FIELD17":"1694008",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PK",
    "FIELD2":"PAK",
    "FIELD3":"586",
    "FIELD4":"PK",
    "FIELD5":"Pakistan",
    "FIELD6":"Islamabad",
    "FIELD7":"803940",
    "FIELD8":"184404791",
    "FIELD9":"AS",
    "FIELD10":".pk",
    "FIELD11":"PKR",
    "FIELD12":"Rupee",
    "FIELD13":"92",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ur-PK,en-PK,pa,sd,ps,brh",
    "FIELD17":"1168579",
    "FIELD18":"CN,AF,IR,IN",
    "FIELD19":""
  },
  {
    "FIELD1":"PL",
    "FIELD2":"POL",
    "FIELD3":"616",
    "FIELD4":"PL",
    "FIELD5":"Poland",
    "FIELD6":"Warsaw",
    "FIELD7":"312685",
    "FIELD8":"38500000",
    "FIELD9":"EU",
    "FIELD10":".pl",
    "FIELD11":"PLN",
    "FIELD12":"Zloty",
    "FIELD13":"48",
    "FIELD14":"##-###",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"pl",
    "FIELD17":"798544",
    "FIELD18":"DE,LT,SK,CZ,BY,UA,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"PM",
    "FIELD2":"SPM",
    "FIELD3":"666",
    "FIELD4":"SB",
    "FIELD5":"Saint Pierre and Miquelon",
    "FIELD6":"Saint-Pierre",
    "FIELD7":"242",
    "FIELD8":"7012",
    "FIELD9":"NA",
    "FIELD10":".pm",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"508",
    "FIELD14":"#####",
    "FIELD15":"^(97500)$",
    "FIELD16":"fr-PM",
    "FIELD17":"3424932",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PN",
    "FIELD2":"PCN",
    "FIELD3":"612",
    "FIELD4":"PC",
    "FIELD5":"Pitcairn",
    "FIELD6":"Adamstown",
    "FIELD7":"47",
    "FIELD8":"46",
    "FIELD9":"OC",
    "FIELD10":".pn",
    "FIELD11":"NZD",
    "FIELD12":"Dollar",
    "FIELD13":"870",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-PN",
    "FIELD17":"4030699",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PR",
    "FIELD2":"PRI",
    "FIELD3":"630",
    "FIELD4":"RQ",
    "FIELD5":"Puerto Rico",
    "FIELD6":"San Juan",
    "FIELD7":"9104",
    "FIELD8":"3916632",
    "FIELD9":"NA",
    "FIELD10":".pr",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-787 and 1-939",
    "FIELD14":"#####-####",
    "FIELD15":"^(\\d{9})$",
    "FIELD16":"en-PR,es-PR",
    "FIELD17":"4566966",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PS",
    "FIELD2":"PSE",
    "FIELD3":"275",
    "FIELD4":"WE",
    "FIELD5":"Palestinian Territory",
    "FIELD6":"East Jerusalem",
    "FIELD7":"5970",
    "FIELD8":"3800000",
    "FIELD9":"AS",
    "FIELD10":".ps",
    "FIELD11":"ILS",
    "FIELD12":"Shekel",
    "FIELD13":"970",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-PS",
    "FIELD17":"6254930",
    "FIELD18":"JO,IL,EG",
    "FIELD19":""
  },
  {
    "FIELD1":"PT",
    "FIELD2":"PRT",
    "FIELD3":"620",
    "FIELD4":"PO",
    "FIELD5":"Portugal",
    "FIELD6":"Lisbon",
    "FIELD7":"92391",
    "FIELD8":"10676000",
    "FIELD9":"EU",
    "FIELD10":".pt",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"351",
    "FIELD14":"####-###",
    "FIELD15":"^(\\d{7})$",
    "FIELD16":"pt-PT,mwl",
    "FIELD17":"2264397",
    "FIELD18":"ES",
    "FIELD19":""
  },
  {
    "FIELD1":"PW",
    "FIELD2":"PLW",
    "FIELD3":"585",
    "FIELD4":"PS",
    "FIELD5":"Palau",
    "FIELD6":"Melekeok",
    "FIELD7":"458",
    "FIELD8":"19907",
    "FIELD9":"OC",
    "FIELD10":".pw",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"680",
    "FIELD14":"96940",
    "FIELD15":"^(96940)$",
    "FIELD16":"pau,sov,en-PW,tox,ja,fil,zh",
    "FIELD17":"1559582",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"PY",
    "FIELD2":"PRY",
    "FIELD3":"600",
    "FIELD4":"PA",
    "FIELD5":"Paraguay",
    "FIELD6":"Asuncion",
    "FIELD7":"406750",
    "FIELD8":"6375830",
    "FIELD9":"SA",
    "FIELD10":".py",
    "FIELD11":"PYG",
    "FIELD12":"Guarani",
    "FIELD13":"595",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"es-PY,gn",
    "FIELD17":"3437598",
    "FIELD18":"BO,BR,AR",
    "FIELD19":""
  },
  {
    "FIELD1":"QA",
    "FIELD2":"QAT",
    "FIELD3":"634",
    "FIELD4":"QA",
    "FIELD5":"Qatar",
    "FIELD6":"Doha",
    "FIELD7":"11437",
    "FIELD8":"840926",
    "FIELD9":"AS",
    "FIELD10":".qa",
    "FIELD11":"QAR",
    "FIELD12":"Rial",
    "FIELD13":"974",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-QA,es",
    "FIELD17":"289688",
    "FIELD18":"SA",
    "FIELD19":""
  },
  {
    "FIELD1":"RE",
    "FIELD2":"REU",
    "FIELD3":"638",
    "FIELD4":"RE",
    "FIELD5":"Reunion",
    "FIELD6":"Saint-Denis",
    "FIELD7":"2517",
    "FIELD8":"776948",
    "FIELD9":"AF",
    "FIELD10":".re",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"262",
    "FIELD14":"#####",
    "FIELD15":"^((97|98)(4|7|8)\\d{2})$",
    "FIELD16":"fr-RE",
    "FIELD17":"935317",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"RO",
    "FIELD2":"ROU",
    "FIELD3":"642",
    "FIELD4":"RO",
    "FIELD5":"Romania",
    "FIELD6":"Bucharest",
    "FIELD7":"237500",
    "FIELD8":"21959278",
    "FIELD9":"EU",
    "FIELD10":".ro",
    "FIELD11":"RON",
    "FIELD12":"Leu",
    "FIELD13":"40",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"ro,hu,rom",
    "FIELD17":"798549",
    "FIELD18":"MD,HU,UA,BG,RS",
    "FIELD19":""
  },
  {
    "FIELD1":"RS",
    "FIELD2":"SRB",
    "FIELD3":"688",
    "FIELD4":"RI",
    "FIELD5":"Serbia",
    "FIELD6":"Belgrade",
    "FIELD7":"88361",
    "FIELD8":"7344847",
    "FIELD9":"EU",
    "FIELD10":".rs",
    "FIELD11":"RSD",
    "FIELD12":"Dinar",
    "FIELD13":"381",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"sr,hu,bs,rom",
    "FIELD17":"6290252",
    "FIELD18":"AL,HU,MK,RO,HR,BA,BG,ME,XK",
    "FIELD19":""
  },
  {
    "FIELD1":"RU",
    "FIELD2":"RUS",
    "FIELD3":"643",
    "FIELD4":"RS",
    "FIELD5":"Russia",
    "FIELD6":"Moscow",
    "FIELD7":"17100000",
    "FIELD8":"140702000",
    "FIELD9":"EU",
    "FIELD10":".ru",
    "FIELD11":"RUB",
    "FIELD12":"Ruble",
    "FIELD13":"7",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"ru,tt,xal,cau,ady,kv,ce,tyv,cv,udm,tut,mns,bua,myv,mdf,chm,ba,inh,tut,kbd,krc,ava,sah,nog",
    "FIELD17":"2017370",
    "FIELD18":"GE,CN,BY,UA,KZ,LV,PL,EE,LT,FI,MN,NO,AZ,KP",
    "FIELD19":""
  },
  {
    "FIELD1":"RW",
    "FIELD2":"RWA",
    "FIELD3":"646",
    "FIELD4":"RW",
    "FIELD5":"Rwanda",
    "FIELD6":"Kigali",
    "FIELD7":"26338",
    "FIELD8":"11055976",
    "FIELD9":"AF",
    "FIELD10":".rw",
    "FIELD11":"RWF",
    "FIELD12":"Franc",
    "FIELD13":"250",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"rw,en-RW,fr-RW,sw",
    "FIELD17":"49518",
    "FIELD18":"TZ,CD,BI,UG",
    "FIELD19":""
  },
  {
    "FIELD1":"SA",
    "FIELD2":"SAU",
    "FIELD3":"682",
    "FIELD4":"SA",
    "FIELD5":"Saudi Arabia",
    "FIELD6":"Riyadh",
    "FIELD7":"1960582",
    "FIELD8":"25731776",
    "FIELD9":"AS",
    "FIELD10":".sa",
    "FIELD11":"SAR",
    "FIELD12":"Rial",
    "FIELD13":"966",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-SA",
    "FIELD17":"102358",
    "FIELD18":"QA,OM,IQ,YE,JO,AE,KW",
    "FIELD19":""
  },
  {
    "FIELD1":"SB",
    "FIELD2":"SLB",
    "FIELD3":"090",
    "FIELD4":"BP",
    "FIELD5":"Solomon Islands",
    "FIELD6":"Honiara",
    "FIELD7":"28450",
    "FIELD8":"559198",
    "FIELD9":"OC",
    "FIELD10":".sb",
    "FIELD11":"SBD",
    "FIELD12":"Dollar",
    "FIELD13":"677",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-SB,tpi",
    "FIELD17":"2103350",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SC",
    "FIELD2":"SYC",
    "FIELD3":"690",
    "FIELD4":"SE",
    "FIELD5":"Seychelles",
    "FIELD6":"Victoria",
    "FIELD7":"455",
    "FIELD8":"88340",
    "FIELD9":"AF",
    "FIELD10":".sc",
    "FIELD11":"SCR",
    "FIELD12":"Rupee",
    "FIELD13":"248",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-SC,fr-SC",
    "FIELD17":"241170",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SD",
    "FIELD2":"SDN",
    "FIELD3":"729",
    "FIELD4":"SU",
    "FIELD5":"Sudan",
    "FIELD6":"Khartoum",
    "FIELD7":"1861484",
    "FIELD8":"35000000",
    "FIELD9":"AF",
    "FIELD10":".sd",
    "FIELD11":"SDG",
    "FIELD12":"Pound",
    "FIELD13":"249",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"ar-SD,en,fia",
    "FIELD17":"366755",
    "FIELD18":"SS,TD,EG,ET,ER,LY,CF",
    "FIELD19":""
  },
  {
    "FIELD1":"SS",
    "FIELD2":"SSD",
    "FIELD3":"728",
    "FIELD4":"OD",
    "FIELD5":"South Sudan",
    "FIELD6":"Juba",
    "FIELD7":"644329",
    "FIELD8":"8260490",
    "FIELD9":"AF",
    "FIELD10":"",
    "FIELD11":"SSP",
    "FIELD12":"Pound",
    "FIELD13":"211",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en",
    "FIELD17":"7909807",
    "FIELD18":"CD,CF,ET,KE,SD,UG,",
    "FIELD19":""
  },
  {
    "FIELD1":"SE",
    "FIELD2":"SWE",
    "FIELD3":"752",
    "FIELD4":"SW",
    "FIELD5":"Sweden",
    "FIELD6":"Stockholm",
    "FIELD7":"449964",
    "FIELD8":"9555893",
    "FIELD9":"EU",
    "FIELD10":".se",
    "FIELD11":"SEK",
    "FIELD12":"Krona",
    "FIELD13":"46",
    "FIELD14":"### ##",
    "FIELD15":"^(?:SE)*(\\d{5})$",
    "FIELD16":"sv-SE,se,sma,fi-SE",
    "FIELD17":"2661886",
    "FIELD18":"NO,FI",
    "FIELD19":""
  },
  {
    "FIELD1":"SG",
    "FIELD2":"SGP",
    "FIELD3":"702",
    "FIELD4":"SN",
    "FIELD5":"Singapore",
    "FIELD6":"Singapur",
    "FIELD7":"692.7",
    "FIELD8":"4701069",
    "FIELD9":"AS",
    "FIELD10":".sg",
    "FIELD11":"SGD",
    "FIELD12":"Dollar",
    "FIELD13":"65",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"cmn,en-SG,ms-SG,ta-SG,zh-SG",
    "FIELD17":"1880251",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SH",
    "FIELD2":"SHN",
    "FIELD3":"654",
    "FIELD4":"SH",
    "FIELD5":"Saint Helena",
    "FIELD6":"Jamestown",
    "FIELD7":"410",
    "FIELD8":"7460",
    "FIELD9":"AF",
    "FIELD10":".sh",
    "FIELD11":"SHP",
    "FIELD12":"Pound",
    "FIELD13":"290",
    "FIELD14":"STHL 1ZZ",
    "FIELD15":"^(STHL1ZZ)$",
    "FIELD16":"en-SH",
    "FIELD17":"3370751",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SI",
    "FIELD2":"SVN",
    "FIELD3":"705",
    "FIELD4":"SI",
    "FIELD5":"Slovenia",
    "FIELD6":"Ljubljana",
    "FIELD7":"20273",
    "FIELD8":"2007000",
    "FIELD9":"EU",
    "FIELD10":".si",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"386",
    "FIELD14":"####",
    "FIELD15":"^(?:SI)*(\\d{4})$",
    "FIELD16":"sl,sh",
    "FIELD17":"3190538",
    "FIELD18":"HU,IT,HR,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"SJ",
    "FIELD2":"SJM",
    "FIELD3":"744",
    "FIELD4":"SV",
    "FIELD5":"Svalbard and Jan Mayen",
    "FIELD6":"Longyearbyen",
    "FIELD7":"62049",
    "FIELD8":"2550",
    "FIELD9":"EU",
    "FIELD10":".sj",
    "FIELD11":"NOK",
    "FIELD12":"Krone",
    "FIELD13":"47",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"no,ru",
    "FIELD17":"607072",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SK",
    "FIELD2":"SVK",
    "FIELD3":"703",
    "FIELD4":"LO",
    "FIELD5":"Slovakia",
    "FIELD6":"Bratislava",
    "FIELD7":"48845",
    "FIELD8":"5455000",
    "FIELD9":"EU",
    "FIELD10":".sk",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"421",
    "FIELD14":"### ##",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"sk,hu",
    "FIELD17":"3057568",
    "FIELD18":"PL,HU,CZ,UA,AT",
    "FIELD19":""
  },
  {
    "FIELD1":"SL",
    "FIELD2":"SLE",
    "FIELD3":"694",
    "FIELD4":"SL",
    "FIELD5":"Sierra Leone",
    "FIELD6":"Freetown",
    "FIELD7":"71740",
    "FIELD8":"5245695",
    "FIELD9":"AF",
    "FIELD10":".sl",
    "FIELD11":"SLL",
    "FIELD12":"Leone",
    "FIELD13":"232",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-SL,men,tem",
    "FIELD17":"2403846",
    "FIELD18":"LR,GN",
    "FIELD19":""
  },
  {
    "FIELD1":"SM",
    "FIELD2":"SMR",
    "FIELD3":"674",
    "FIELD4":"SM",
    "FIELD5":"San Marino",
    "FIELD6":"San Marino",
    "FIELD7":"61.2",
    "FIELD8":"31477",
    "FIELD9":"EU",
    "FIELD10":".sm",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"378",
    "FIELD14":"4789#",
    "FIELD15":"^(4789\\d)$",
    "FIELD16":"it-SM",
    "FIELD17":"3168068",
    "FIELD18":"IT",
    "FIELD19":""
  },
  {
    "FIELD1":"SN",
    "FIELD2":"SEN",
    "FIELD3":"686",
    "FIELD4":"SG",
    "FIELD5":"Senegal",
    "FIELD6":"Dakar",
    "FIELD7":"196190",
    "FIELD8":"12323252",
    "FIELD9":"AF",
    "FIELD10":".sn",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"221",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-SN,wo,fuc,mnk",
    "FIELD17":"2245662",
    "FIELD18":"GN,MR,GW,GM,ML",
    "FIELD19":""
  },
  {
    "FIELD1":"SO",
    "FIELD2":"SOM",
    "FIELD3":"706",
    "FIELD4":"SO",
    "FIELD5":"Somalia",
    "FIELD6":"Mogadishu",
    "FIELD7":"637657",
    "FIELD8":"10112453",
    "FIELD9":"AF",
    "FIELD10":".so",
    "FIELD11":"SOS",
    "FIELD12":"Shilling",
    "FIELD13":"252",
    "FIELD14":"@@  #####",
    "FIELD15":"^([A-Z]{2}\\d{5})$",
    "FIELD16":"so-SO,ar-SO,it,en-SO",
    "FIELD17":"51537",
    "FIELD18":"ET,KE,DJ",
    "FIELD19":""
  },
  {
    "FIELD1":"SR",
    "FIELD2":"SUR",
    "FIELD3":"740",
    "FIELD4":"NS",
    "FIELD5":"Suriname",
    "FIELD6":"Paramaribo",
    "FIELD7":"163270",
    "FIELD8":"492829",
    "FIELD9":"SA",
    "FIELD10":".sr",
    "FIELD11":"SRD",
    "FIELD12":"Dollar",
    "FIELD13":"597",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"nl-SR,en,srn,hns,jv",
    "FIELD17":"3382998",
    "FIELD18":"GY,BR,GF",
    "FIELD19":""
  },
  {
    "FIELD1":"ST",
    "FIELD2":"STP",
    "FIELD3":"678",
    "FIELD4":"TP",
    "FIELD5":"Sao Tome and Principe",
    "FIELD6":"Sao Tome",
    "FIELD7":"1001",
    "FIELD8":"175808",
    "FIELD9":"AF",
    "FIELD10":".st",
    "FIELD11":"STD",
    "FIELD12":"Dobra",
    "FIELD13":"239",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"pt-ST",
    "FIELD17":"2410758",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"SV",
    "FIELD2":"SLV",
    "FIELD3":"222",
    "FIELD4":"ES",
    "FIELD5":"El Salvador",
    "FIELD6":"San Salvador",
    "FIELD7":"21040",
    "FIELD8":"6052064",
    "FIELD9":"NA",
    "FIELD10":".sv",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"503",
    "FIELD14":"CP ####",
    "FIELD15":"^(?:CP)*(\\d{4})$",
    "FIELD16":"es-SV",
    "FIELD17":"3585968",
    "FIELD18":"GT,HN",
    "FIELD19":""
  },
  {
    "FIELD1":"SX",
    "FIELD2":"SXM",
    "FIELD3":"534",
    "FIELD4":"NN",
    "FIELD5":"Sint Maarten",
    "FIELD6":"Philipsburg",
    "FIELD7":"21",
    "FIELD8":"37429",
    "FIELD9":"NA",
    "FIELD10":".sx",
    "FIELD11":"ANG",
    "FIELD12":"Guilder",
    "FIELD13":"599",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"nl,en",
    "FIELD17":"7609695",
    "FIELD18":"MF",
    "FIELD19":""
  },
  {
    "FIELD1":"SY",
    "FIELD2":"SYR",
    "FIELD3":"760",
    "FIELD4":"SY",
    "FIELD5":"Syria",
    "FIELD6":"Damascus",
    "FIELD7":"185180",
    "FIELD8":"22198110",
    "FIELD9":"AS",
    "FIELD10":".sy",
    "FIELD11":"SYP",
    "FIELD12":"Pound",
    "FIELD13":"963",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-SY,ku,hy,arc,fr,en",
    "FIELD17":"163843",
    "FIELD18":"IQ,JO,IL,TR,LB",
    "FIELD19":""
  },
  {
    "FIELD1":"SZ",
    "FIELD2":"SWZ",
    "FIELD3":"748",
    "FIELD4":"WZ",
    "FIELD5":"Swaziland",
    "FIELD6":"Mbabane",
    "FIELD7":"17363",
    "FIELD8":"1354051",
    "FIELD9":"AF",
    "FIELD10":".sz",
    "FIELD11":"SZL",
    "FIELD12":"Lilangeni",
    "FIELD13":"268",
    "FIELD14":"@###",
    "FIELD15":"^([A-Z]\\d{3})$",
    "FIELD16":"en-SZ,ss-SZ",
    "FIELD17":"934841",
    "FIELD18":"ZA,MZ",
    "FIELD19":""
  },
  {
    "FIELD1":"TC",
    "FIELD2":"TCA",
    "FIELD3":"796",
    "FIELD4":"TK",
    "FIELD5":"Turks and Caicos Islands",
    "FIELD6":"Cockburn Town",
    "FIELD7":"430",
    "FIELD8":"20556",
    "FIELD9":"NA",
    "FIELD10":".tc",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-649",
    "FIELD14":"TKCA 1ZZ",
    "FIELD15":"^(TKCA 1ZZ)$",
    "FIELD16":"en-TC",
    "FIELD17":"3576916",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TD",
    "FIELD2":"TCD",
    "FIELD3":"148",
    "FIELD4":"CD",
    "FIELD5":"Chad",
    "FIELD6":"N'Djamena",
    "FIELD7":"1284000",
    "FIELD8":"10543464",
    "FIELD9":"AF",
    "FIELD10":".td",
    "FIELD11":"XAF",
    "FIELD12":"Franc",
    "FIELD13":"235",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-TD,ar-TD,sre",
    "FIELD17":"2434508",
    "FIELD18":"NE,LY,CF,SD,CM,NG",
    "FIELD19":""
  },
  {
    "FIELD1":"TF",
    "FIELD2":"ATF",
    "FIELD3":"260",
    "FIELD4":"FS",
    "FIELD5":"French Southern Territories",
    "FIELD6":"Port-aux-Francais",
    "FIELD7":"7829",
    "FIELD8":"140",
    "FIELD9":"AN",
    "FIELD10":".tf",
    "FIELD11":"EUR",
    "FIELD12":"Euro  ",
    "FIELD13":"",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr",
    "FIELD17":"1546748",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TG",
    "FIELD2":"TGO",
    "FIELD3":"768",
    "FIELD4":"TO",
    "FIELD5":"Togo",
    "FIELD6":"Lome",
    "FIELD7":"56785",
    "FIELD8":"6587239",
    "FIELD9":"AF",
    "FIELD10":".tg",
    "FIELD11":"XOF",
    "FIELD12":"Franc",
    "FIELD13":"228",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"fr-TG,ee,hna,kbp,dag,ha",
    "FIELD17":"2363686",
    "FIELD18":"BJ,GH,BF",
    "FIELD19":""
  },
  {
    "FIELD1":"TH",
    "FIELD2":"THA",
    "FIELD3":"764",
    "FIELD4":"TH",
    "FIELD5":"Thailand",
    "FIELD6":"Bangkok",
    "FIELD7":"514000",
    "FIELD8":"67089500",
    "FIELD9":"AS",
    "FIELD10":".th",
    "FIELD11":"THB",
    "FIELD12":"Baht",
    "FIELD13":"66",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"th,en",
    "FIELD17":"1605651",
    "FIELD18":"LA,MM,KH,MY",
    "FIELD19":""
  },
  {
    "FIELD1":"TJ",
    "FIELD2":"TJK",
    "FIELD3":"762",
    "FIELD4":"TI",
    "FIELD5":"Tajikistan",
    "FIELD6":"Dushanbe",
    "FIELD7":"143100",
    "FIELD8":"7487489",
    "FIELD9":"AS",
    "FIELD10":".tj",
    "FIELD11":"TJS",
    "FIELD12":"Somoni",
    "FIELD13":"992",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"tg,ru",
    "FIELD17":"1220409",
    "FIELD18":"CN,AF,KG,UZ",
    "FIELD19":""
  },
  {
    "FIELD1":"TK",
    "FIELD2":"TKL",
    "FIELD3":"772",
    "FIELD4":"TL",
    "FIELD5":"Tokelau",
    "FIELD6":"",
    "FIELD7":"10",
    "FIELD8":"1466",
    "FIELD9":"OC",
    "FIELD10":".tk",
    "FIELD11":"NZD",
    "FIELD12":"Dollar",
    "FIELD13":"690",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"tkl,en-TK",
    "FIELD17":"4031074",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TL",
    "FIELD2":"TLS",
    "FIELD3":"626",
    "FIELD4":"TT",
    "FIELD5":"East Timor",
    "FIELD6":"Dili",
    "FIELD7":"15007",
    "FIELD8":"1154625",
    "FIELD9":"OC",
    "FIELD10":".tl",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"670",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"tet,pt-TL,id,en",
    "FIELD17":"1966436",
    "FIELD18":"ID",
    "FIELD19":""
  },
  {
    "FIELD1":"TM",
    "FIELD2":"TKM",
    "FIELD3":"795",
    "FIELD4":"TX",
    "FIELD5":"Turkmenistan",
    "FIELD6":"Ashgabat",
    "FIELD7":"488100",
    "FIELD8":"4940916",
    "FIELD9":"AS",
    "FIELD10":".tm",
    "FIELD11":"TMT",
    "FIELD12":"Manat",
    "FIELD13":"993",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"tk,ru,uz",
    "FIELD17":"1218197",
    "FIELD18":"AF,IR,UZ,KZ",
    "FIELD19":""
  },
  {
    "FIELD1":"TN",
    "FIELD2":"TUN",
    "FIELD3":"788",
    "FIELD4":"TS",
    "FIELD5":"Tunisia",
    "FIELD6":"Tunis",
    "FIELD7":"163610",
    "FIELD8":"10589025",
    "FIELD9":"AF",
    "FIELD10":".tn",
    "FIELD11":"TND",
    "FIELD12":"Dinar",
    "FIELD13":"216",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"ar-TN,fr",
    "FIELD17":"2464461",
    "FIELD18":"DZ,LY",
    "FIELD19":""
  },
  {
    "FIELD1":"TO",
    "FIELD2":"TON",
    "FIELD3":"776",
    "FIELD4":"TN",
    "FIELD5":"Tonga",
    "FIELD6":"Nuku'alofa",
    "FIELD7":"748",
    "FIELD8":"122580",
    "FIELD9":"OC",
    "FIELD10":".to",
    "FIELD11":"TOP",
    "FIELD12":"Pa'anga",
    "FIELD13":"676",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"to,en-TO",
    "FIELD17":"4032283",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TR",
    "FIELD2":"TUR",
    "FIELD3":"792",
    "FIELD4":"TU",
    "FIELD5":"Turkey",
    "FIELD6":"Ankara",
    "FIELD7":"780580",
    "FIELD8":"77804122",
    "FIELD9":"AS",
    "FIELD10":".tr",
    "FIELD11":"TRY",
    "FIELD12":"Lira",
    "FIELD13":"90",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"tr-TR,ku,diq,az,av",
    "FIELD17":"298795",
    "FIELD18":"SY,GE,IQ,IR,GR,AM,AZ,BG",
    "FIELD19":""
  },
  {
    "FIELD1":"TT",
    "FIELD2":"TTO",
    "FIELD3":"780",
    "FIELD4":"TD",
    "FIELD5":"Trinidad and Tobago",
    "FIELD6":"Port of Spain",
    "FIELD7":"5128",
    "FIELD8":"1228691",
    "FIELD9":"NA",
    "FIELD10":".tt",
    "FIELD11":"TTD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-868",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-TT,hns,fr,es,zh",
    "FIELD17":"3573591",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TV",
    "FIELD2":"TUV",
    "FIELD3":"798",
    "FIELD4":"TV",
    "FIELD5":"Tuvalu",
    "FIELD6":"Funafuti",
    "FIELD7":"26",
    "FIELD8":"10472",
    "FIELD9":"OC",
    "FIELD10":".tv",
    "FIELD11":"AUD",
    "FIELD12":"Dollar",
    "FIELD13":"688",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"tvl,en,sm,gil",
    "FIELD17":"2110297",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TW",
    "FIELD2":"TWN",
    "FIELD3":"158",
    "FIELD4":"TW",
    "FIELD5":"Taiwan",
    "FIELD6":"Taipei",
    "FIELD7":"35980",
    "FIELD8":"22894384",
    "FIELD9":"AS",
    "FIELD10":".tw",
    "FIELD11":"TWD",
    "FIELD12":"Dollar",
    "FIELD13":"886",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"zh-TW,zh,nan,hak",
    "FIELD17":"1668284",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"TZ",
    "FIELD2":"TZA",
    "FIELD3":"834",
    "FIELD4":"TZ",
    "FIELD5":"Tanzania",
    "FIELD6":"Dodoma",
    "FIELD7":"945087",
    "FIELD8":"41892895",
    "FIELD9":"AF",
    "FIELD10":".tz",
    "FIELD11":"TZS",
    "FIELD12":"Shilling",
    "FIELD13":"255",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"sw-TZ,en,ar",
    "FIELD17":"149590",
    "FIELD18":"MZ,KE,CD,RW,ZM,BI,UG,MW",
    "FIELD19":""
  },
  {
    "FIELD1":"UA",
    "FIELD2":"UKR",
    "FIELD3":"804",
    "FIELD4":"UP",
    "FIELD5":"Ukraine",
    "FIELD6":"Kiev",
    "FIELD7":"603700",
    "FIELD8":"45415596",
    "FIELD9":"EU",
    "FIELD10":".ua",
    "FIELD11":"UAH",
    "FIELD12":"Hryvnia",
    "FIELD13":"380",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"uk,ru-UA,rom,pl,hu",
    "FIELD17":"690791",
    "FIELD18":"PL,MD,HU,SK,BY,RO,RU",
    "FIELD19":""
  },
  {
    "FIELD1":"UG",
    "FIELD2":"UGA",
    "FIELD3":"800",
    "FIELD4":"UG",
    "FIELD5":"Uganda",
    "FIELD6":"Kampala",
    "FIELD7":"236040",
    "FIELD8":"33398682",
    "FIELD9":"AF",
    "FIELD10":".ug",
    "FIELD11":"UGX",
    "FIELD12":"Shilling",
    "FIELD13":"256",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-UG,lg,sw,ar",
    "FIELD17":"226074",
    "FIELD18":"TZ,KE,SS,CD,RW",
    "FIELD19":""
  },
  {
    "FIELD1":"UM",
    "FIELD2":"UMI",
    "FIELD3":"581",
    "FIELD4":"",
    "FIELD5":"United States Minor Outlying Islands",
    "FIELD6":"",
    "FIELD7":"0",
    "FIELD8":"0",
    "FIELD9":"OC",
    "FIELD10":".um",
    "FIELD11":"USD",
    "FIELD12":"Dollar ",
    "FIELD13":"1",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-UM",
    "FIELD17":"5854968",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"US",
    "FIELD2":"USA",
    "FIELD3":"840",
    "FIELD4":"US",
    "FIELD5":"United States",
    "FIELD6":"Washington",
    "FIELD7":"9629091",
    "FIELD8":"310232863",
    "FIELD9":"NA",
    "FIELD10":".us",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"1",
    "FIELD14":"#####-####",
    "FIELD15":"^\\d{5}(-\\d{4})?$",
    "FIELD16":"en-US,es-US,haw,fr",
    "FIELD17":"6252001",
    "FIELD18":"CA,MX,CU",
    "FIELD19":""
  },
  {
    "FIELD1":"UY",
    "FIELD2":"URY",
    "FIELD3":"858",
    "FIELD4":"UY",
    "FIELD5":"Uruguay",
    "FIELD6":"Montevideo",
    "FIELD7":"176220",
    "FIELD8":"3477000",
    "FIELD9":"SA",
    "FIELD10":".uy",
    "FIELD11":"UYU",
    "FIELD12":"Peso",
    "FIELD13":"598",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"es-UY",
    "FIELD17":"3439705",
    "FIELD18":"BR,AR",
    "FIELD19":""
  },
  {
    "FIELD1":"UZ",
    "FIELD2":"UZB",
    "FIELD3":"860",
    "FIELD4":"UZ",
    "FIELD5":"Uzbekistan",
    "FIELD6":"Tashkent",
    "FIELD7":"447400",
    "FIELD8":"27865738",
    "FIELD9":"AS",
    "FIELD10":".uz",
    "FIELD11":"UZS",
    "FIELD12":"Som",
    "FIELD13":"998",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"uz,ru,tg",
    "FIELD17":"1512440",
    "FIELD18":"TM,AF,KG,TJ,KZ",
    "FIELD19":""
  },
  {
    "FIELD1":"VA",
    "FIELD2":"VAT",
    "FIELD3":"336",
    "FIELD4":"VT",
    "FIELD5":"Vatican",
    "FIELD6":"Vatican City",
    "FIELD7":"0.44",
    "FIELD8":"921",
    "FIELD9":"EU",
    "FIELD10":".va",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"379",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"la,it,fr",
    "FIELD17":"3164670",
    "FIELD18":"IT",
    "FIELD19":""
  },
  {
    "FIELD1":"VC",
    "FIELD2":"VCT",
    "FIELD3":"670",
    "FIELD4":"VC",
    "FIELD5":"Saint Vincent and the Grenadines",
    "FIELD6":"Kingstown",
    "FIELD7":"389",
    "FIELD8":"104217",
    "FIELD9":"NA",
    "FIELD10":".vc",
    "FIELD11":"XCD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-784",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-VC,fr",
    "FIELD17":"3577815",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"VE",
    "FIELD2":"VEN",
    "FIELD3":"862",
    "FIELD4":"VE",
    "FIELD5":"Venezuela",
    "FIELD6":"Caracas",
    "FIELD7":"912050",
    "FIELD8":"27223228",
    "FIELD9":"SA",
    "FIELD10":".ve",
    "FIELD11":"VEF",
    "FIELD12":"Bolivar",
    "FIELD13":"58",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"es-VE",
    "FIELD17":"3625428",
    "FIELD18":"GY,BR,CO",
    "FIELD19":""
  },
  {
    "FIELD1":"VG",
    "FIELD2":"VGB",
    "FIELD3":"092",
    "FIELD4":"VI",
    "FIELD5":"British Virgin Islands",
    "FIELD6":"Road Town",
    "FIELD7":"153",
    "FIELD8":"21730",
    "FIELD9":"NA",
    "FIELD10":".vg",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-284",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-VG",
    "FIELD17":"3577718",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"VI",
    "FIELD2":"VIR",
    "FIELD3":"850",
    "FIELD4":"VQ",
    "FIELD5":"U.S. Virgin Islands",
    "FIELD6":"Charlotte Amalie",
    "FIELD7":"352",
    "FIELD8":"108708",
    "FIELD9":"NA",
    "FIELD10":".vi",
    "FIELD11":"USD",
    "FIELD12":"Dollar",
    "FIELD13":"+1-340",
    "FIELD14":"#####-####",
    "FIELD15":"^\\d{5}(-\\d{4})?$",
    "FIELD16":"en-VI",
    "FIELD17":"4796775",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"VN",
    "FIELD2":"VNM",
    "FIELD3":"704",
    "FIELD4":"VM",
    "FIELD5":"Vietnam",
    "FIELD6":"Hanoi",
    "FIELD7":"329560",
    "FIELD8":"89571130",
    "FIELD9":"AS",
    "FIELD10":".vn",
    "FIELD11":"VND",
    "FIELD12":"Dong",
    "FIELD13":"84",
    "FIELD14":"######",
    "FIELD15":"^(\\d{6})$",
    "FIELD16":"vi,en,fr,zh,km",
    "FIELD17":"1562822",
    "FIELD18":"CN,LA,KH",
    "FIELD19":""
  },
  {
    "FIELD1":"VU",
    "FIELD2":"VUT",
    "FIELD3":"548",
    "FIELD4":"NH",
    "FIELD5":"Vanuatu",
    "FIELD6":"Port Vila",
    "FIELD7":"12200",
    "FIELD8":"221552",
    "FIELD9":"OC",
    "FIELD10":".vu",
    "FIELD11":"VUV",
    "FIELD12":"Vatu",
    "FIELD13":"678",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"bi,en-VU,fr-VU",
    "FIELD17":"2134431",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"WF",
    "FIELD2":"WLF",
    "FIELD3":"876",
    "FIELD4":"WF",
    "FIELD5":"Wallis and Futuna",
    "FIELD6":"Mata Utu",
    "FIELD7":"274",
    "FIELD8":"16025",
    "FIELD9":"OC",
    "FIELD10":".wf",
    "FIELD11":"XPF",
    "FIELD12":"Franc",
    "FIELD13":"681",
    "FIELD14":"#####",
    "FIELD15":"^(986\\d{2})$",
    "FIELD16":"wls,fud,fr-WF",
    "FIELD17":"4034749",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"WS",
    "FIELD2":"WSM",
    "FIELD3":"882",
    "FIELD4":"WS",
    "FIELD5":"Samoa",
    "FIELD6":"Apia",
    "FIELD7":"2944",
    "FIELD8":"192001",
    "FIELD9":"OC",
    "FIELD10":".ws",
    "FIELD11":"WST",
    "FIELD12":"Tala",
    "FIELD13":"685",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"sm,en-WS",
    "FIELD17":"4034894",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"YE",
    "FIELD2":"YEM",
    "FIELD3":"887",
    "FIELD4":"YM",
    "FIELD5":"Yemen",
    "FIELD6":"Sanaa",
    "FIELD7":"527970",
    "FIELD8":"23495361",
    "FIELD9":"AS",
    "FIELD10":".ye",
    "FIELD11":"YER",
    "FIELD12":"Rial",
    "FIELD13":"967",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"ar-YE",
    "FIELD17":"69543",
    "FIELD18":"SA,OM",
    "FIELD19":""
  },
  {
    "FIELD1":"YT",
    "FIELD2":"MYT",
    "FIELD3":"175",
    "FIELD4":"MF",
    "FIELD5":"Mayotte",
    "FIELD6":"Mamoudzou",
    "FIELD7":"374",
    "FIELD8":"159042",
    "FIELD9":"AF",
    "FIELD10":".yt",
    "FIELD11":"EUR",
    "FIELD12":"Euro",
    "FIELD13":"262",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"fr-YT",
    "FIELD17":"1024031",
    "FIELD18":"",
    "FIELD19":""
  },
  {
    "FIELD1":"ZA",
    "FIELD2":"ZAF",
    "FIELD3":"710",
    "FIELD4":"SF",
    "FIELD5":"South Africa",
    "FIELD6":"Pretoria",
    "FIELD7":"1219912",
    "FIELD8":"49000000",
    "FIELD9":"AF",
    "FIELD10":".za",
    "FIELD11":"ZAR",
    "FIELD12":"Rand",
    "FIELD13":"27",
    "FIELD14":"####",
    "FIELD15":"^(\\d{4})$",
    "FIELD16":"zu,xh,af,nso,en-ZA,tn,st,ts,ss,ve,nr",
    "FIELD17":"953987",
    "FIELD18":"ZW,SZ,MZ,BW,NA,LS",
    "FIELD19":""
  },
  {
    "FIELD1":"ZM",
    "FIELD2":"ZMB",
    "FIELD3":"894",
    "FIELD4":"ZA",
    "FIELD5":"Zambia",
    "FIELD6":"Lusaka",
    "FIELD7":"752614",
    "FIELD8":"13460305",
    "FIELD9":"AF",
    "FIELD10":".zm",
    "FIELD11":"ZMW",
    "FIELD12":"Kwacha",
    "FIELD13":"260",
    "FIELD14":"#####",
    "FIELD15":"^(\\d{5})$",
    "FIELD16":"en-ZM,bem,loz,lun,lue,ny,toi",
    "FIELD17":"895949",
    "FIELD18":"ZW,TZ,MZ,CD,NA,MW,AO",
    "FIELD19":""
  },
  {
    "FIELD1":"ZW",
    "FIELD2":"ZWE",
    "FIELD3":"716",
    "FIELD4":"ZI",
    "FIELD5":"Zimbabwe",
    "FIELD6":"Harare",
    "FIELD7":"390580",
    "FIELD8":"11651858",
    "FIELD9":"AF",
    "FIELD10":".zw",
    "FIELD11":"ZWL",
    "FIELD12":"Dollar",
    "FIELD13":"263",
    "FIELD14":"",
    "FIELD15":"",
    "FIELD16":"en-ZW,sn,nr,nd",
    "FIELD17":"878675",
    "FIELD18":"ZA,MZ,BW,ZM",
    "FIELD19":""
  }
];